<template>
  <!-- index头部：外层在伴学打开时仍展示（bol=false 的任务页也可出面板），导航区单独 v-show="bol" -->
  <div
    class="HeaderBox"
    v-show="headerVisible"
    :class="[
      headerBoxRouteClass,
      { 'HeaderBox--chrome-hidden': !bol && aiAssistantVisible },
      { 'HeaderBox--ai-assistant-open': aiAssistantVisible }
    ]"
    ref="HeaderBox"
    id="HeaderBox"
  >
    <div class="header-box-chrome" v-show="bol">
    <div class="ward">
      <div class="left">
        <div class="logo_img cursor" @click="$router.push('/')">
          <img src="https://img.webloom.cn/img/sylogo1.png" v-if="!isScroll">
          <img src="https://img.webloom.cn/img/sylogo2.png" alt="" v-else>
        </div>
        <div class="list">
          <div class="item cursor fontColor"
            v-for="(o, index) in list"
            :key="o.title.zh"
            :ref="'a'+index"
            @click="navBtn(index, o.title.zh)">
            <div v-if="o.title.zh=='项目活动'">
              <img src="//img.webloom.cn/img/up.png" alt="" class="upTriangle" v-show="dropBol">
              <season-drop :projectList="projectList" :title="o.title[lang]" @bol="bolChange">
                <template slot="title">
                  <div class="nav-project-title" :style="isScroll ? 'color: #030A17;' : ''">
                    {{o.title[lang]}}
                    <img
                      class="nav-project-arrow"
                      :src="isScroll ? 'https://img.webloom.cn/Img/xiangmuxialahei.png' : 'https://img.webloom.cn/Img/xiangmuxialabai.png'"
                      alt=""
                    >
                  </div>
                </template>
              </season-drop>
            </div>
            <div v-else-if="o.title.zh=='活动广场'">
              <plaza-drop :title="o.title[lang]" :style="isScroll ? 'color: #030A17;' : ''">
                <div :class="{'selectItem': itemIndex == index}">{{o.title[lang]}}</div>
              </plaza-drop>
            </div>
            <span v-else class="nav-item-label" :style="isScroll ? 'color: #030A17;' : ''">
              {{o.title[lang]}}
              <img src="https://img.webloom.cn/img/sydaohanglanbg.png" alt="" class="bottomLine" v-if="(o.title.zh =='首页' && routeName == 'Index') || (o.title.zh =='发现' && routeName == 'DiscoverHome')" v-show="!isScroll">
              <img src="https://img.webloom.cn/img/sydaohanglanbglan.png" alt="" class="bottomLine" v-if="(o.title.zh =='首页' && routeName == 'Index') || (o.title.zh =='发现' && routeName == 'DiscoverHome')" v-show="isScroll">
            </span>
          </div>
        </div>
      </div>
      <!-- 登录右边 -->
      <div class="right">
        <div class="iconBox">
          <button
            type="button"
            class="ai-entry-pill"
            :class="{ 'ai-entry-pill--locale-zh': lang === 'zh' }"
            :aria-label="$t('aiStudyBuddy.title')"
            @click="openAiAssistantFromHeader"
          >
            <img
              class="ai-entry-pill__img"
              :src="aiAssistantEntryBannerSrc"
              alt=""
              draggable="false"
            />
            <span
              v-if="aiAssistantEntryTargetTab !== 'newChat' && aiAssistantEntryPlaceholder"
              class="ai-entry-pill__fake-input"
              aria-hidden="true"
            >{{'|  ' + aiAssistantEntryPlaceholder }}</span>
            <img
              class="ai-entry-pill__tail-icon"
              src="https://img.webloom.cn/Img/aisousuoIcon.webp"
              alt=""
              draggable="false"
            />
          </button>
          <div class="activity cursor" v-if="EventPlazaBtn" @click="activityBtn">
            <img :src="isScroll ? 'https://img.webloom.cn/img/xiaoxihei.png' : 'https://img.webloom.cn/img/xiaoxibai.png'" alt="">
            <div class="num" v-if="+unRead>0">{{+unRead>99?'99':unRead}}</div>
          </div>
        </div>
        <div class="coachBtn cursor" v-if="isLogin && (userType==1)" @click="goCoach"  :style="isScroll ? 'border: 1px solid #296BFF; color: #296BFF;' : ''">{{$t('tabs.toCoach')}}</div>
        <a ref="coachBtna" class="none" :href="coachHref" target="_blank"></a>
        <div class="user_icon cursor" v-if="isLogin">
          <el-popover
            @show="headerPopoverShow"
            popper-class="headerPopover"
            placement="bottom"
            trigger="hover">
              <div class="popoverCent">
                <div class="contentItem" @click="handleCommand('MyActivities')">
                  <div class="itemIn" @mouseenter="contentItemMouseover">
                    <div></div>
                    <img src="https://img.webloom.cn/img/dropdownicon1.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon1act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.activity')}}</div>
                  </div>
                </div>
                <div class="contentItem" @click="handleCommand('MySociety')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/img/dropdownicon2.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon2act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.society')}}</div>
                  </div>
                </div>
                <div class="contentItem" @click="handleCommand('battleCenter')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/img/dropdownicon3.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon3act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.battleCenter')}}</div>
                  </div>
                </div>
                <div class="contentItem" @click="handleCommand('MyOrder')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/img/dropdownicon4.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon4act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.orders')}}</div>
                  </div>
                </div>
                <div class="contentItem" @click="handleCommand('MessageUs')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/Img/gondan0.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/Img/gondan1.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">
                      {{$t('mine.messageUs')}}
                      <div class="TicketNum" v-if="TicketNum> 0">{{TicketNum > 99 ? '99+' : TicketNum}}</div>
                      <!--<div class="TicketNum">9</div>-->
                    </div>
                  </div>
                </div>
                <!---->
                <div class="contentItem"  @click="handleCommand('setting')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/img/dropdownicon5.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon5act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.setting')}}</div>
                  </div>
                </div>
                <div class="contentItem exitBox"  @click="handleCommand('logout')">
                  <div class="itemIn">
                    <img src="https://img.webloom.cn/img/dropdownicon6.png" alt="" class="itemInIcon">
                    <img src="https://img.webloom.cn/img/dropdownicon6act.png" alt="" class="itemInIcon1">
                    <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn exit' : 'itemInTxt exit'">{{$t('mine.quite')}}</div>
                  </div>
                </div>
              </div>
            <div class="img_container" @click="checkStatu" slot="reference">
              <img :src="hearderImg" onerror="this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null" />
            </div>
          </el-popover>
        </div>
        <template v-else>
          <div class="btnBlue cursor" @click="handleLogin" v-if="isScroll">{{$t('tabs.loginOrRes')}}</div>
          <div class="btn cursor" @click="handleLogin" v-else :style="isScroll ? 'border: 1px solid #296BFF; color: #296BFF;' : 'border: 1px solid #fff;'">{{$t('tabs.loginOrRes')}}</div>
        </template>
        <div class="myActivit cursor" @click="handleCommand('MyActivities')" :style="isScroll ? 'border: 1px solid #296BFF; color: #296BFF;' : ''">{{$t('mine.activity')}}</div>
      </div>
    </div>
    <div class="change-lang cursor" @click="changeLang" :style="isScroll ? '' : 'border-color: #fff'">
      <template v-if="isScroll">
        <span :class="{active: $i18n.locale == 'en'}">EN</span>/<span :class="{active: $i18n.locale != 'en'}">中</span>
      </template>
      <template v-else>
        <span :class="{active: $i18n.locale == 'en'}" :style="isScroll ? '#D7D7D7FF' : ($i18n.locale !== 'en' ? 'color: #fff; opacity:0.5' : 'color: #fff; opacity:1')">EN</span><span :style="isScroll? '#D7D7D7FF' : 'color: #fff'">/</span><span :class="{active: $i18n.locale == 'en'}" :style="isScroll? '#D7D7D7FF' : ($i18n.locale == 'en' ? 'color: #fff; opacity:0.5' : 'color: #fff; opacity:1')">中</span>
      </template>
    </div>
  </div>
    <!-- AI 伴学助手：几乎全屏弹窗（头部栏保持可见，不改变头部布局） -->
    <transition name="ai-assistant-fade">
      <div
        ref="aiAssistantPanel"
        v-show="aiAssistantVisible"
        class="ai-assistant-panel"
        :class="{
          'ai-assistant-panel--compact': aiAssistantCompact,
          'ai-assistant-panel--compact-nav-open': aiAssistantCompact && aiCompactSidebarOpen,
          'ai-assistant-panel--locale-en': $i18n.locale === 'en',
          'ai-assistant-panel--bloom-route': !bol
        }"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        :aria-label="$t('aiStudyBuddy.title')"
        @keydown.esc.stop="onAiAssistantEsc"
      >
        <div class="ai-assistant-panel-body">
        <aside ref="aiAssistantSidebar" class="ai-assistant-sidebar">
          <button
            type="button"
            class="ai-side-item"
            :class="{ 'is-active': aiSidebarTab === 'recommend' }"
            @click="setAiSidebarTab('recommend')"
          >
            <img class="ai-side-icon" src="https://img.webloom.cn/Img/aiRecommendation.webp" alt="" />
            <span class="ai-side-label">{{ $t('aiStudyBuddy.sidebarRecommend') }}</span>
          </button>
          <button
            type="button"
            class="ai-side-item"
            :class="{ 'is-active': aiSidebarTab === 'topic' }"
            @click="setAiSidebarTab('topic')"
          >
            <img class="ai-side-icon" src="https://img.webloom.cn/Img/aiTopic.webp" alt="" />
            <span class="ai-side-label">{{ $t('aiStudyBuddy.sidebarTopic') }}</span>
          </button>
          <div class="ai-sidebar-history-block">
            <button
              type="button"
              class="ai-side-item ai-side-item--history"
              :aria-expanded="(aiChatHistory.length && aiHistorySidebarExpanded) ? 'true' : 'false'"
              @click="toggleAiHistorySidebarExpand"
            >
              <img class="ai-side-icon" src="https://img.webloom.cn/Img/aiHistory.webp" alt="" />
              <span class="ai-side-label">{{ $t('aiStudyBuddy.sidebarHistory') }}</span>
              <img
                class="ai-side-chevron-img"
                :class="{ 'ai-side-chevron-img--rotated': !aiHistorySidebarExpanded }"
                src="https://img.webloom.cn/Img/ai-dorp.webp"
                alt=""
                width="13"
                height="8"
                @click.stop="toggleAiHistorySidebarExpand"
              />
            </button>
            <div
              v-show="aiChatHistory.length && aiHistorySidebarExpanded"
              class="ai-sidebar-history-list"
            >
              <ul class="ai-sidebar-history-items">
                <li
                  v-for="item in aiChatHistory"
                  :key="item.fromServer ? 's-' + item.aiDialogueId : item.id"
                  class="ai-sidebar-history-li"
                >
                  <el-tooltip
                    effect="dark"
                    popper-class="ai-sidebar-history-tooltip"
                    :content="historyItemTooltipText(item)"
                    placement="right"
                    :open-delay="200"
                  >
                    <button
                      type="button"
                      class="ai-sidebar-history-link"
                      :class="{ 'is-selected': item.id === aiSelectedHistoryId }"
                      @click.stop="selectAiHistoryItem(item)"
                    >
                      {{ item.preview }}
                    </button>
                  </el-tooltip>
                </li>
              </ul>
            </div>
          </div>
        </aside>
        <div
          v-show="aiAssistantCompact && aiCompactSidebarOpen"
          class="ai-compact-sidebar-backdrop"
          aria-hidden="true"
          @click="closeAiCompactNav"
        />
        <div class="ai-assistant-main">
          <header v-show="aiAssistantCompact" class="ai-compact-header">
            <button
              type="button"
              class="ai-compact-menu"
              :aria-label="aiCompactSidebarOpen ? $t('aiStudyBuddy.ariaCloseMenu') : $t('aiStudyBuddy.ariaOpenMenu')"
              :aria-expanded="aiCompactSidebarOpen ? 'true' : 'false'"
              @click="toggleAiCompactNav"
            >
              <img
                class="ai-compact-menu-icon"
                src="https://img.webloom.cn/Img/aiMemu.png"
                alt=""
                width="20"
                height="16"
              />
            </button>
            <span class="ai-compact-title">{{ $t('aiStudyBuddy.title') }}</span>
            <button type="button" class="ai-compact-close" :aria-label="$t('aiStudyBuddy.ariaClose')" @click="closeAiAssistant">
              <span aria-hidden="true">×</span>
            </button>
          </header>
          <button
            v-show="!aiAssistantCompact"
            type="button"
            class="ai-assistant-close"
            :aria-label="$t('aiStudyBuddy.ariaClose')"
            @click="closeAiAssistant"
          >
            <img
              src="https://img.webloom.cn/Img/aiCLOSE.png"
              alt=""
              aria-hidden="true"
              class="ai-assistant-close-img"
            />
          </button>
          <div class="ai-main-column">
          <div ref="aiChatScroll" class="ai-chat-scroll" @scroll="onAiChatScroll">
            <!-- 开启新对话：推荐入口页 -->
            <template v-if="aiSidebarTab === 'newChat'">
              <div class="ai-newchat-wrap">
                <p v-if="aiAssistantCompact" class="ai-newchat-greet">
                  {{ $t('aiStudyBuddy.compactGreet') }}
                </p>
                <p v-else class="ai-newchat-greet">{{ $t('aiStudyBuddy.newChatGreet') }}</p>
                <div class="ai-newchat-cards">
                  <button
                    type="button"
                    class="ai-feature-card ai-feature-card--recommend"
                    @click="setAiSidebarTab('recommend')"
                  >
                    <div class="ai-feature-card-text">
                      <h3 class="ai-feature-card-title">{{ $t('aiStudyBuddy.cardRecommendTitle') }}</h3>
                      <p class="ai-feature-card-desc">{{ $t('aiStudyBuddy.cardRecommendDesc') }}</p>
                    </div>
                  </button>
                  <button
                    type="button"
                    class="ai-feature-card ai-feature-card--topic"
                    @click="setAiSidebarTab('topic')"
                  >
                    <div class="ai-feature-card-text">
                      <h3 class="ai-feature-card-title">{{ $t('aiStudyBuddy.cardTopicTitle') }}</h3>
                      <p class="ai-feature-card-desc">{{ $t('aiStudyBuddy.cardTopicDesc') }}</p>
                    </div>
                  </button>
                </div>
              </div>
            </template>
            <!-- 推荐活动 -->
            <template v-else-if="aiSidebarTab === 'recommend'">
              <p class="ai-msg ai-msg--assistant">
                {{ $t('aiStudyBuddy.recommendIntro') }}
                <br>
                {{ $t('aiStudyBuddy.recommendQuestion') }}
              </p>
              <!--<div class="ai-msg ai-msg&#45;&#45;user">我想参加数据分析相关的竞赛，最好能和 Python、Pandas 结合。</div>-->
              <!--<div class="ai-recommend-row">-->
              <!--  <article class="ai-activity-card">-->
              <!--    <header class="ai-card-head">-->
              <!--      <h3 class="ai-card-title">2025 AI大模型应用创新大赛</h3>-->
              <!--      <span class="ai-card-tag ai-card-tag&#45;&#45;open">报名中</span>-->
              <!--    </header>-->
              <!--    <ul class="ai-card-meta">-->
              <!--      <li><span class="dot dot-b"></span>挑战：大模型落地场景设计与实现</li>-->
              <!--      <li><span class="dot dot-g"></span>时间：2025.04.01 — 2025.08.31</li>-->
              <!--      <li><span class="dot dot-o"></span>要求：团队 2–5 人，提交方案与 Demo</li>-->
              <!--      <li><span class="dot dot-y"></span>推荐指数：★★★★☆</li>-->
              <!--      <li><span class="dot dot-p"></span>推荐理由：与数据分析、工程实践结合紧密</li>-->
              <!--    </ul>-->
              <!--    <button type="button" class="ai-card-btn">查看活动详情 &gt;&gt;</button>-->
              <!--  </article>-->
              <!--  <article class="ai-activity-card">-->
              <!--    <header class="ai-card-head">-->
              <!--      <h3 class="ai-card-title">全国大学生数据智能挑战赛</h3>-->
              <!--      <span class="ai-card-tag ai-card-tag&#45;&#45;end">已结束</span>-->
              <!--    </header>-->
              <!--    <ul class="ai-card-meta">-->
              <!--      <li><span class="dot dot-b"></span>挑战：电商销售数据挖掘与可视化</li>-->
              <!--      <li><span class="dot dot-g"></span>时间：2024.09.01 — 2024.12.20</li>-->
              <!--      <li><span class="dot dot-o"></span>要求：熟悉 Python 数据分析栈</li>-->
              <!--      <li><span class="dot dot-y"></span>推荐指数：★★★★★</li>-->
              <!--      <li><span class="dot dot-p"></span>推荐理由：高度匹配 Python、Pandas 技能</li>-->
              <!--    </ul>-->
              <!--    <button type="button" class="ai-card-btn">查看活动详情 &gt;&gt;</button>-->
              <!--  </article>-->
              <!--</div>-->
            </template>
            <!-- AI 生成选题 -->
            <template v-else-if="aiSidebarTab === 'topic'">
              <p class="ai-msg ai-msg--assistant">
                {{ $t('aiStudyBuddy.topicIntro') }}
                <br>
                {{ $t('aiStudyBuddy.topicQuestion') }}
              </p>
            </template>
            <!-- 历史对话：选中项在主区展示为对话视图；DIALOGUE_SEND 成功后再进入与历史一致的 waitAgentRes 等待态 -->
            <template v-else-if="aiSidebarTab === 'history'">
              <template v-if="selectedHistoryItem || aiShowEntryBootstrapChat">
                <template v-if="aiShowEntryBootstrapChat || (selectedHistoryItem && selectedHistoryItem.fromServer)">
                  <template v-if="aiHistoryMsgList.length">
                    <div
                      v-for="row in aiHistoryMsgRowsForView"
                      :key="row.aiDialogueChatRecordId"
                      class="ai-history-msg-turn"
                    >
                      <div v-if="row.userReq && !String(row.im750ErrorTip || '').trim()" class="ai-msg ai-msg--user">{{ row.userReq }}</div>
                      <div class="ai-answer-slot">
                        <div
                          v-show="row.answerThinkingVisible"
                          class="ai-answer-wait-loading"
                          aria-live="polite"
                        >
                          <img
                            class="ai-answer-wait-loading__icon"
                            src="https://img.webloom.cn/Img/chatLodding.gif"
                            width="20"
                            height="20"
                            alt=""
                          />
                          <span class="ai-answer-wait-loading__text">
                            {{ $t('aiStudyBuddy.thinkingBase') }}<span class="ai-answer-wait-loading__dots">{{ aiThinkingDotsSuffix }}</span>
                          </span>
                        </div>
                        <div
                          v-show="!row.answerThinkingVisible"
                          class="ai-answer-below-thinking"
                        >
                      <div
                        v-if="String(row.im750ErrorTip || '').trim()"
                        class="ai-msg ai-msg--assistant ai-im750-error-tip"
                        role="alert"
                      >{{ row.im750ErrorTip }}</div>
                      <div
                        v-if="row._asaStoppedWithNoContent"
                        class="ai-im750-user-stop-tip"
                        role="status"
                      >{{ $t('aiStudyBuddy.userStoppedNoContentTip') }}</div>
                      <template v-if="row.agentRes">
                        <div
                          v-for="(part, pi) in row.agentResParts"
                          :key="String(row.aiDialogueChatRecordId) + '-ar-' + pi"
                          class="ai-agent-res-part"
                        >
                          <ai-streaming-text
                            v-if="part.type === 'text'"
                            :text="part.text != null ? String(part.text) : ''"
                            :streaming="agentResStreamLive(row)"
                            :typing-dots-active="agentResPartShowsStreamTypingDots(row, part, pi)"
                            @stream-tick="scrollAiChatToBottomStream"
                          />
                          <div
                            v-else-if="part.type === 'cards'"
                            class="ai-contest-cards-wrap"
                          >
                            <article
                              v-for="(card, ci) in part.cards"
                              :key="(card.contestId != null ? String(card.contestId) : 'c') + '-' + ci"
                              class="ai-contest-recommend-card"
                            >
                              <span
                                class="ai-cr-badge"
                                :class="'ai-cr-badge--' + contestRegistrationBadge(card).mod"
                              >{{ contestRegistrationBadge(card).text }}</span>
                              <div class="ai-cr-card-body">
                                <div class="ai-cr-row ai-cr-row--challenge">
                                  <span class="ai-cr-ico" aria-hidden="true">
                                    <img
                                      class="ai-cr-ico-img"
                                      src="https://img.webloom.cn/Img/aiCard-zhishu.png"
                                      alt=""
                                    />
                                  </span>
                                  <div class="ai-cr-row-text">
                                    <div class="ai-cr-kv ai-cr-kv--challenge">
                                      <span class="ai-cr-label">{{ $t('aiStudyBuddy.cardActivityName') }}</span>
                                      <span class="ai-cr-name">{{ aiContestCardTitleText(card) }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ai-cr-row">
                                  <span class="ai-cr-ico" aria-hidden="true">
                                    <img
                                      class="ai-cr-ico-img"
                                      src="https://img.webloom.cn/Img/aiCard-baomingshijian.png"
                                      alt=""
                                    />
                                  </span>
                                  <div class="ai-cr-row-text">
                                    <div class="ai-cr-kv">
                                      <span class="ai-cr-label">{{ $t('aiStudyBuddy.cardRegistrationPeriod') }}</span>
                                      <span class="ai-cr-value">{{ formatContestEnterRange(card) }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ai-cr-row">
                                  <span class="ai-cr-ico" aria-hidden="true">
                                    <img
                                      class="ai-cr-ico-img"
                                      src="https://img.webloom.cn/Img/aiCard-baomingtiaojian.png"
                                      alt=""
                                    />
                                  </span>
                                  <div class="ai-cr-row-text">
                                    <div class="ai-cr-kv">
                                      <span class="ai-cr-label">{{ $t('aiStudyBuddy.cardEligibility') }}</span>
                                      <span class="ai-cr-value">{{ formatContestGradeRange(card) }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ai-cr-row">
                                  <span class="ai-cr-ico" aria-hidden="true">
                                    <img
                                      class="ai-cr-ico-img"
                                      src="https://img.webloom.cn/Img/aiCard-tuijian.png"
                                      alt=""
                                    />
                                  </span>
                                  <div class="ai-cr-row-text">
                                    <div class="ai-cr-kv ai-cr-kv--stars">
                                      <span class="ai-cr-label">{{ $t('aiStudyBuddy.cardRecommendationLevel') }}</span>
                                      <span
                                        class="ai-cr-stars"
                                        :aria-label="aiContestRatingAria(card)"
                                      >
                                        <div
                                          v-for="n in 5"
                                          :key="n"
                                          class="ai-cr-star-item"
                                        >
                                          <img
                                            :src="n <= normalizeContestRating(card.ratNum) ? aiContestCardStarImgs.on : aiContestCardStarImgs.off"
                                            alt=""
                                          />
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ai-cr-row ai-cr-row--last">
                                  <span class="ai-cr-ico" aria-hidden="true">
                                    <img
                                      class="ai-cr-ico-img"
                                      src="https://img.webloom.cn/Img/aiCard-liyou.png"
                                      alt=""
                                    />
                                  </span>
                                  <div class="ai-cr-row-text">
                                    <div class="ai-cr-kv ai-cr-kv--reason">
                                      <span class="ai-cr-label">{{ $t('aiStudyBuddy.cardWhyRecommended') }}</span>
                                      <p class="ai-cr-reason">{{ card.reason || '—' }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <button
                                type="button"
                                class="ai-cr-detail-btn"
                                @click="openAiContestDetailFromCard(card)"
                              >{{ $t('aiStudyBuddy.viewActivityDetails') }}</button>
                            </article>
                          </div>
                          <ai-assistant-topic-fence
                            v-else-if="part.type === 'topicFence'"
                            :topic-tree="part.topicTree"
                            :topic-list="part.topicList"
                            :panel-compact="aiAssistantCompact"
                          />
                        </div>
                      </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else-if="selectedHistoryItem && !selectedHistoryItem.fromServer">
                  <div class="ai-msg ai-msg--user">{{ selectedHistoryItem.text }}</div>
                  <p class="ai-msg ai-msg--assistant">{{ $t('aiStudyBuddy.localHistoryPlaceholder') }}</p>
                </template>
              </template>
              <p
                v-else-if="!aiChatHistory.length"
                class="ai-msg ai-msg--assistant ai-history-main-hint"
              >{{ $t('aiStudyBuddy.historyEmpty') }}</p>
              <p v-else class="ai-msg ai-msg--assistant ai-history-main-hint">{{ $t('aiStudyBuddy.historySelectHint') }}</p>
            </template>
          </div>
          <div class="ai-assistant-footer">
            <div
              v-show="showAiQuickChips && aiSidebarTab === 'newChat'"
              class="ai-prompts-wrap"
              :class="{ 'ai-prompts-wrap--compact': aiAssistantCompact }"
            >
              <div class="ai-quick-prompts">
                <button
                  v-for="chip in aiQuickChips"
                  :key="'ai-kp-' + chip.poolIndex"
                  type="button"
                  class="ai-chip"
                  :disabled="aiAssistantTextareaDisabled"
                  @click="setAiInput(chip.value)"
                >
                  <span class="ai-chip-title">{{ chipTitleDisplay(chip) }}</span>
                  <span v-if="chipHintDisplay(chip)" class="ai-chip-hint">{{ chipHintDisplay(chip) }}</span>
                </button>
              </div>
            </div>
            <div
              class="ai-input-wrap"
              :class="{ 'ai-input-wrap--locked': aiAssistantTextareaDisabled }"
            >
              <div class="ai-input-gradient">
                <textarea
                  ref="aiInputField"
                  v-model="aiInputText"
                  class="ai-input-field"
                  rows="1"
                  maxlength="5000"
                  :placeholder="aiInputPlaceholder"
                  :disabled="aiAssistantTextareaDisabled"
                  @input="adjustAiTextareaHeight"
                  @keydown="onAiInputKeydown"
                />
                <div v-if="!aiAssistantCompact" class="ai-send-row">
                  <button
                    type="button"
                    class="ai-send-btn"
                    :disabled="aiAssistantSendButtonDisabled"
                    :aria-label="aiAssistantSendButtonAria"
                    @click="onAiSendOrStop"
                  >
                    <img
                      :src="(aiAssistantWaitingImReply || aiSendLoading) ? 'https://img.webloom.cn/Img/aiSendIng.webp' : 'https://img.webloom.cn/Img/aiSend.webp'"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <div v-if="aiAssistantCompact" class="ai-compact-footer-bar">
              <p class="ai-disclaimer">{{ $t('aiStudyBuddy.disclaimer') }}</p>
              <div class="ai-send-row">
                <button
                  type="button"
                  class="ai-send-btn"
                  :disabled="aiAssistantSendButtonDisabled"
                  :aria-label="aiAssistantSendButtonAria"
                  @click="onAiSendOrStop"
                >
                  <img
                    :src="(aiAssistantWaitingImReply || aiSendLoading) ? 'https://img.webloom.cn/Img/aiSendIng.webp' : 'https://img.webloom.cn/Img/aiSend.webp'"
                    alt=""
                  />
                </button>
              </div>
            </div>
            <p v-else class="ai-disclaimer">{{ $t('aiStudyBuddy.disclaimer') }}</p>
          </div>
          </div>
        </div>
        </div>
        <button
          type="button"
          class="ai-assistant-shrink-btn"
          :aria-label="aiAssistantCompact ? $t('aiStudyBuddy.ariaExpandFull') : $t('aiStudyBuddy.ariaShrinkWindow')"
          @click="onAiAssistantShrink"
        >
          <img
            class="ai-assistant-shrink-btn-icon"
            :class="{ 'ai-assistant-shrink-btn-icon--expanded': aiAssistantCompact }"
            src="https://img.webloom.cn/Img/%E6%94%B6%E8%B5%B7%20(2)%402x.webp"
            alt=""
            width="14"
            height="10"
          />
        </button>
      </div>
    </transition>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import seasonDrop from './season-drop'
import PlazaDrop from './plaza-drop'
import AiAssistantTopicFence from './ai-assistant-topic-fence.vue'
import AiStreamingText from './ai-streaming-text.vue'
import { ensureCustomerImReady, destroyCustomerImOnError } from '../../assets/js/customerImBootstrap'
import { AI_QUICK_KNOWLEDGE_PROMPTS } from '../../assets/js/aiQuickKnowledgePrompts'
import {
  mergeIm750AgentResState,
  getIm750SortMeta,
  getIm750RecordBuffer,
  setIm750RecordBuffer,
  removeIm750RecordBuffer,
  clearIm750RecordBuffers,
  IM750_WAIT_FORCE_MS
} from '@/utils/im750SortBuffer'
import { debounceLead } from '@/utils/debounceLead'

export default {
  data () {
    return {
      TicketNum: 0, // 工单未读数量
      isMounted: false,
      EventPlazaBtn: true,  // 活动消息按钮
      coachHref: '',
      userType: 0,           // 是否为教练  1是
      projectList: [],
      bol: false,            // 是否显示隐藏头部
      itemIndex: 0,
      list: [{
        title: {zh: '首页', en: 'Home', name: 'Index'}, width: 0, path: '/'
      }, {
        title: {zh: '项目活动', en: 'Projects and Activities', name: 'GameData'}, width: 0, path: '/'
      },
      {
        title: {zh: '发现', en: 'Discover', name: 'DiscoverHome'}, width: 0, path: '/discoverHome'
      }
      ],
      hearderImg: '',    // 头像
      userId: '',
      dropBol: false,
      isScroll: false,
      routeName: 'index',
      canGetNum: true,
      aiAssistantVisible: false,
      /** true：420px 窄条；false：接近全屏 */
      aiAssistantCompact: false,
      /** 窄条模式下侧栏抽屉是否打开 */
      aiCompactSidebarOpen: false,
      aiInputText: '',
      /** 左侧 AI 弹窗 tab：recommend | topic | history（newChat 已隐藏） */
      aiSidebarTab: 'recommend',
      /** 在「开启新对话」中发送的消息会写入此处，供「历史对话」展示 */
      aiChatHistory: [],
      /** 侧栏历史子列表展开；仅初始为收起（本页首次打开伴学）；关闭后再开沿用关闭前状态；展开时再拉 DIALOGUE_LIST */
      aiHistorySidebarExpanded: false,
      /** 当前选中的历史记录 id，侧栏高亮 + 主区展示对应对话 */
      aiSelectedHistoryId: null,
      /** 当前选中会话的聊天记录（DIALOGUE_MSGLOG），仅服务端会话有值 */
      aiHistoryMsgList: [],
      aiHistoryMsgInitialLoading: false,
      aiHistoryMsgLoadingMore: false,
      aiHistoryMsgPageSize: 10,
      aiHistoryMsgStartIndex: 0,
      aiHistoryMsgTotalCount: 0,
      aiHistoryMsgHasMore: false,
      aiSendLoading: false,
      aiAssistantUnreadCount: 0,
      /** 头部入口条右侧「假输入」占位文案（无输入能力，随机三选一），由 initAiAssistantEntryPlaceholder 写入 */
      aiAssistantEntryPlaceholder: '',
      /** 与占位文案对应的左侧 tab：recommend | topic */
      aiAssistantEntryTargetTab: 'recommend',
      /**
       * 为 true：用户尚未关闭过伴学面板（本页生命周期内）；此时从关闭状态点头部的伴学入口会按随机提示词切 tab。
       * 任意一次关闭（closeAiAssistant）后置 false，之后再次打开仅恢复关闭前内存状态，不再改 tab。
       */
      aiAssistantHeaderEntryTabPending: true,
      /** 伴学流式滚动：与 H5 scrollAiChatToBottomStream 一致，rAF 合并 */
      _aiStreamScrollRaf: null,
      /** 当前正在查看的会话 id（用于 IM 消息过滤） */
      aiCurrentDialogueId: null,
      /**
       * 切走其他历史前：对「仍在等 IM/流式未结束」的会话做快照 (aiDialogueId → { rows })。
       * 切回时与 DIALOGUE_MSGLOG 合并；在后台时 750 继续写入该 rows，避免丢等待态与半包。
       */
      aiDialogueStreamCache: {},
      /** 用户主动停止生成后丢弃的 aiDialogueChatRecordId（仅本轮） */
      _im750AbortedRecordIds: null,
      /** kind=error 后丢弃同 aiDialogueChatRecordId 的后续 IM 750 */
      _im750ErrorRecordIds: null,
      /** 停止时尚无服务端 recordId：用 dialogueId + userReq 对齐首条 IM */
      _im750AbortPending: null,
      /** aiDialogueChatRecordId → 已收到该 id 的任一条 750 IM（在合并 agentRes 前即置位，用于彻底关掉思考中与流式叠显） */
      _aiIm750FirstPacketSeen: {},
      /** 伴学回答区「思考中」动态省略号：0→'.' 1→'..' 2→'...' */
      aiThinkingDotsPhase: 0,
      _aiThinkingDotsTimer: null,
      /** 伴学快捷知识点：从 10 条池中随机 3 条的池内下标，进入「新对话」时刷新 */
      aiQuickChipsPickIds: [],
      /** 从 newChat/recommend/topic 首条发送后切到历史主区展示等待态，直至 DIALOGUE_SEND 成功 */
      aiEntrySendPending: false,
      /** 与 aiEntrySendPending 配对：发送失败时回到原 tab */
      aiEntrySendOriginTab: null,
      /**
       * DIALOGUE_SEND 成功且新建会话后：在 MSGLOG 首屏拉取完成后再合并/追加 waitAgentRes 行（避免先发后失败仍占位）
       * { dialogueId, userText, sendData }
       */
      _aiAfterSendNeedWaitRow: null,
      /** IM750 等待超时轮询（兜底时长见 IM750_WAIT_FORCE_MS） */
      _im750WaitForceTick: null
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      activityMessage: state => state.common.activityMessage,
      unRead: state => state.login.unRead,
      customerImParsedMessage: state => state.customerIm.lastParsedMessage,
      hideGlobalHeader: state => state.common.hideGlobalHeader
      // 下标距离
    }),
    headerVisible () {
      return (this.bol || this.aiAssistantVisible) && !this.hideGlobalHeader
    },
    left () {
      let num = 0
      if (this.itemIndex < 0) return
      for (let i = 0; i < this.itemIndex; i++) {
        num = num + this.list[i].width
      }
      num = num + (this.list[this.itemIndex].width - 28) / 2
      return num
    },
    lang: {
      get: function () {
        return this.$i18n.locale === 'en' ? 'en' : 'zh'
      },
      set: function (val) {
        this.$i18n.locale = val
      }
    },
    showAiQuickChips () {
      return !String(this.aiInputText || '').trim()
    },
    selectedHistoryItem () {
      const id = this.aiSelectedHistoryId
      if (id == null) return null
      return this.aiChatHistory.find(h => h.id === id) || null
    },
    /** 三 tab 首条发送：主区用与历史会话相同的聊天气泡 + chatLodding 等待态 */
    aiShowEntryBootstrapChat () {
      return this.aiEntrySendPending && (this.aiHistoryMsgList || []).length > 0
    },
    /** 伴学助手头部入口横幅：中文 webp / 英文 png，随语言切换 */
    aiAssistantEntryBannerSrc () {
      return this.$i18n.locale === 'en'
        ? 'https://img.webloom.cn/Img/banxue2en.webp'
        : 'https://img.webloom.cn/Img/banxue2cn.webp'
      // ? 'https://img.webloom.cn/Img/aisousuoEn.png'
      // : 'https://img.webloom.cn/Img/aisousuoNewq.webp'
    },
    /** 伴学活动卡片星级图（与 bloom-H5 asa-recommend-card icoUrls.starOn/starOff 一致） */
    aiContestCardStarImgs () {
      return {
        on: 'https://img.webloom.cn/Img/aistar1.png',
        off: 'https://img.webloom.cn/Img/aistar2.png'
      }
    },
    /** 历史消息行：按顺序解析文案 + ```contestFence``` 卡片 + ```topicTree```/```topicNameListStr``` 选题区 */
    aiHistoryMsgRowsForView () {
      void this._aiIm750FirstPacketSeen
      return (this.aiHistoryMsgList || []).map((row) => {
        const hasIm750Error = String(row.im750ErrorTip || '').trim() !== ''
        const layout = hasIm750Error
          ? { parts: [] }
          : this.buildAgentResContestLayout(row.agentRes)
        return Object.assign({}, row, {
          agentResParts: layout.parts,
          /** 与 agentRes 同源推导，避免模板里方法判断与 v-if="row.agentRes" 竞态导致 loading 与流式叠显 */
          answerThinkingVisible: this.aiAnswerThinkingOverlayVisible(row)
        })
      })
    },
    /** 当前服务端会话内是否有消息仍在等 IM 750（含 complete）结束 */
    aiAssistantWaitingImReply () {
      if (this.aiSidebarTab !== 'history') return false
      if (
        this.aiShowEntryBootstrapChat &&
        (this.aiHistoryMsgList || []).some((r) => r && r.waitAgentRes)
      ) {
        return true
      }
      const sel = this.selectedHistoryItem
      if (!sel || !sel.fromServer) return false
      return (this.aiHistoryMsgList || []).some((r) => r && r.waitAgentRes)
    },
    /**
     * 历史主区是否存在「已发问题、尚未收到首条 IM 内容」的行（用于思考中省略号动画）
     */
    aiAssistantAnswerAreaLoading () {
      void this._aiIm750FirstPacketSeen
      if (this.aiSidebarTab !== 'history') return false
      const list = this.aiHistoryMsgList || []
      return list.some((r) => this.aiAnswerThinkingOverlayVisible(r))
    },
    aiThinkingDotsSuffix () {
      const seq = ['.', '..', '...']
      return seq[this.aiThinkingDotsPhase % 3]
    },
    /** 发送接口请求中，或历史会话内正等待 IM 回复完成：禁用输入区与快捷 chip */
    aiAssistantTextareaDisabled () {
      return this.aiSendLoading || this.aiAssistantWaitingImReply
    },
    /** 仅 DIALOGUE_SEND 请求中禁用发送钮；等待 IM 时钮可点以停止生成 */
    aiAssistantSendButtonDisabled () {
      return this.aiSendLoading
    },
    aiAssistantSendButtonAria () {
      if (this.aiSendLoading) return this.$t('aiStudyBuddy.ariaSendWaiting')
      if (this.aiAssistantWaitingImReply) return this.$t('aiStudyBuddy.ariaStopGeneration')
      return this.$t('aiStudyBuddy.ariaSend')
    },
    /** 发送接口请求中，或历史会话内正等待 IM 回复完成（与 aiAssistantTextareaDisabled 等价，保留旧名供模板少改） */
    aiAssistantInputSendLocked () {
      return this.aiAssistantTextareaDisabled
    },
    /** 与模板中原 $route.meta.needScroll 逻辑一致，且 meta 缺失时不报错 */
    headerBoxRouteClass () {
      const meta = this.$route && this.$route.meta
      const needScroll = meta && meta.needScroll
      return needScroll ? (this.isScroll ? 'HeaderBox1 MT60' : 'MT60') : 'HeaderBox1'
    },
    /** 新对话全屏下用长提示，其余为短占位 */
    aiInputPlaceholder () {
      if (this.aiSidebarTab === 'newChat' && !this.aiAssistantCompact) {
        return this.$t('aiStudyBuddy.knowledgePlaceholder')
      }
      return this.$t('aiStudyBuddy.placeholderInput')
    },
    /** 快捷知识点：随机 3 条；展示「类目」+「问题」，点击仅填入问题 */
    aiQuickChips () {
      const pool = AI_QUICK_KNOWLEDGE_PROMPTS
      const n = pool.length
      const ids = this.aiQuickChipsPickIds.length
        ? this.aiQuickChipsPickIds
        : [0, 1, 2].filter(i => i < n)
      const isEn = this.lang === 'en'
      return ids.map((poolIndex) => {
        const row = pool[poolIndex]
        const category = isEn ? row.categoryEn : row.categoryZh
        const question = isEn ? row.questionEn : row.questionZh
        return {
          poolIndex,
          title: category,
          titleCompact: category,
          hint: question,
          hintCompact: question,
          value: question
        }
      })
    }
  },
  methods: {
    contentItemMouseover (e) {
      console.log(e, 'contentItemMouseover')
    },
    bolChange (e) {
      if (!e) {
        setTimeout(() => {
          this.dropBol = e
        }, 50)
      } else {
        this.dropBol = e
      }
    },
    /** 头部伴学入口：刷新后随机文案，并与首次打开的左侧 tab 一一对应（不含 newChat） */
    initAiAssistantEntryPlaceholder () {
      const entries = [
        { textKey: 'placeholderRecommend', tab: 'recommend' },
        { textKey: 'placeholderTopic', tab: 'topic' }
      ]
      const pick = entries[Math.floor(Math.random() * entries.length)]
      this.aiAssistantEntryPlaceholder = this.$t('aiStudyBuddy.' + pick.textKey)
      this.aiAssistantEntryTargetTab = pick.tab
    },
    /** 展开「历史对话」子列表时再拉 DIALOGUE_LIST（尚无服务端会话时） */
    toggleAiHistorySidebarExpand () {
      const next = !this.aiHistorySidebarExpanded
      this.aiHistorySidebarExpanded = next
      if (next && this.isLogin && !this.aiChatHistory.some((h) => h.fromServer)) {
        this.loadAiDialogueList()
      }
    },
    setAiSidebarTab (tab) {
      if (tab === 'newChat') return
      const prev = this.aiSidebarTab
      if (tab !== 'history' && prev === 'history') {
        const oldDid =
          this.aiCurrentDialogueId != null && this.aiCurrentDialogueId !== ''
            ? String(this.aiCurrentDialogueId)
            : ''
        if (oldDid) {
          const hadUnfinished = (this.aiHistoryMsgList || []).some(
            (r) => r && (r.waitAgentRes === true || this.agentResStreamLive(r))
          )
          if (hadUnfinished) {
            this.$set(this.aiDialogueStreamCache, oldDid, {
              rows: (this.aiHistoryMsgList || []).map((r) =>
                r && typeof r === 'object' ? { ...r } : r
              )
            })
          }
        }
      }
      this.aiSidebarTab = tab
      if (tab === 'newChat' && prev !== 'newChat') {
        this.shuffleAiQuickChipsPick()
      }
      if (tab === 'history') {
        this.aiAssistantUnreadCount = 0
      } else {
        // 离开历史对话时，取消左侧历史项高亮激活态
        this.aiSelectedHistoryId = null
        this.aiCurrentDialogueId = null
      }
      if (this.aiAssistantCompact) {
        this.aiCompactSidebarOpen = false
      }
      this.$nextTick(() => {
        const el = this.$refs.aiChatScroll
        if (el) el.scrollTop = 0
      })
    },
    /** 选中历史记录并停留在历史 tab，主区展示该条对话 */
    selectAiHistoryItem (item) {
      if (!item) return
      if (this._aiAfterSendNeedWaitRow) {
        const pendId = String(this._aiAfterSendNeedWaitRow.dialogueId || '')
        const pickId =
          item.fromServer && item.aiDialogueId != null ? String(item.aiDialogueId) : ''
        if (!item.fromServer || (pickId !== '' && pickId !== pendId)) {
          this._aiAfterSendNeedWaitRow = null
        }
      }
      const newDid = item.fromServer && item.aiDialogueId != null ? String(item.aiDialogueId) : null
      const oldDid = this.aiCurrentDialogueId != null ? String(this.aiCurrentDialogueId) : null
      const hadUnfinished = (this.aiHistoryMsgList || []).some(
        (r) => r && (r.waitAgentRes === true || this.agentResStreamLive(r))
      )
      if (oldDid && newDid && oldDid !== newDid && hadUnfinished) {
        this.$set(this.aiDialogueStreamCache, oldDid, {
          rows: (this.aiHistoryMsgList || []).map((r) =>
            r && typeof r === 'object' ? { ...r } : r
          )
        })
      }
      this.aiAssistantUnreadCount = 0
      this.aiSelectedHistoryId = item.id
      this.aiCurrentDialogueId = item.fromServer ? item.aiDialogueId : null
      this.aiHistoryMsgList = []
      this.aiHistoryMsgInitialLoading = false
      this.aiHistoryMsgLoadingMore = false
      this.aiHistoryMsgStartIndex = 0
      this.aiHistoryMsgTotalCount = 0
      this.aiHistoryMsgHasMore = false
      this.setAiSidebarTab('history')
      this.aiHistorySidebarExpanded = true
      if (item.fromServer && item.aiDialogueId != null) {
        this.loadMoreAiHistoryMsg(true)
      }
    },
    /**
     * 头部伴学入口：打开/聚焦面板（内部实现）。
     * 已打开时再点：沿用原逻辑重置到新对话。
     * 从关闭状态打开：若尚未关闭过伴学（本页内 closeAiAssistant 未执行过），按随机提示词切 tab；
     * 一旦关闭过，再次打开仅 `v-show` 显示面板，不改 tab 与其它状态。
     */
    _openAiAssistantFromHeaderCore () {
      this.$utils.CzcTrackEvent('全局', '进入搜索中间页面')
      const wasAiVisible = this.aiAssistantVisible
      this.aiAssistantUnreadCount = 0
      this.aiAssistantVisible = true
      if (wasAiVisible) {
        this.aiAssistantCompact = false
        this.aiCompactSidebarOpen = false
        this.aiSidebarTab = 'recommend'
        this.aiSelectedHistoryId = null
        this.aiCurrentDialogueId = null
        this.aiHistoryMsgList = []
        this._aiIm750FirstPacketSeen = {}
        this.aiDialogueStreamCache = {}
        clearIm750RecordBuffers()
        this.aiHistoryMsgInitialLoading = false
        this.aiHistoryMsgLoadingMore = false
        this.aiHistoryMsgStartIndex = 0
        this.aiHistoryMsgTotalCount = 0
        this.aiHistoryMsgHasMore = false
        this.loadAiDialogueList()
        this.shuffleAiQuickChipsPick()
      } else if (this.aiAssistantHeaderEntryTabPending) {
        this.setAiSidebarTab(this.aiAssistantEntryTargetTab)
        this.aiAssistantHeaderEntryTabPending = false
      }
      this.$nextTick(() => {
        const panel = this.$el && this.$el.querySelector && this.$el.querySelector('.ai-assistant-panel')
        if (panel) panel.focus()
        this.adjustAiTextareaHeight()
      })
    },
    /** 主头伴学入口 */
    openAiAssistantFromHeader () {
      this._openAiAssistantFromHeaderCore()
    },
    /**
     * 外部入口（如首页生成选题）：打开伴学并选中指定 tab（recommend | topic），可选预填输入框
     */
    openAiAssistantWithTab (tab, prefill) {
      const validTabs = ['recommend', 'topic']
      if (!validTabs.includes(tab)) return
      this.aiAssistantUnreadCount = 0
      this.aiAssistantVisible = true
      this.aiAssistantCompact = false
      this.aiCompactSidebarOpen = false
      this.setAiSidebarTab(tab)
      if (tab === 'topic' && prefill != null && String(prefill).trim() !== '') {
        this.aiInputText = String(prefill).trim()
      }
      this.$nextTick(() => {
        const panel = this.$el && this.$el.querySelector && this.$el.querySelector('.ai-assistant-panel')
        if (panel && panel.focus) panel.focus()
        this.adjustAiTextareaHeight()
      })
    },
    /** 事件总线：open-ai-assistant-with-tab，payload 为 { tab, prefill? } 或直接传 tab 字符串 */
    _onOpenAiAssistantWithTab (payload) {
      const tab = payload && typeof payload === 'object' ? payload.tab : payload
      const prefill =
        payload && typeof payload === 'object' && payload.prefill != null
          ? payload.prefill
          : ''
      this.openAiAssistantWithTab(tab, prefill)
    },
    /**
     * Bloom 活动任务头：打开伴学（内部实现）。始终 aiAssistantCompact=true。
     */
    _openAiAssistantFromBloomHeaderCore () {
      this.$utils.CzcTrackEvent(this.$route.name || '活动任务', '伴学助手入口', 'Bloom头部打开')
      this.aiAssistantUnreadCount = 0
      /** Bloom 头部 nav_ai_banxue_btn：每次打开均使用缩小模式（与是否首次打开无关） */
      this.aiAssistantCompact = true
      this.aiCompactSidebarOpen = false
      if (this.aiAssistantHeaderEntryTabPending) {
        this.aiSidebarTab = 'recommend'
        this.aiSelectedHistoryId = null
        this.aiCurrentDialogueId = null
        this.aiHistoryMsgList = []
        this._aiIm750FirstPacketSeen = {}
        this.aiDialogueStreamCache = {}
        clearIm750RecordBuffers()
        this.aiHistoryMsgInitialLoading = false
        this.aiHistoryMsgLoadingMore = false
        this.aiHistoryMsgStartIndex = 0
        this.aiHistoryMsgTotalCount = 0
        this.aiHistoryMsgHasMore = false
        this.aiAssistantHeaderEntryTabPending = false
        this.shuffleAiQuickChipsPick()
      }
      this.aiAssistantVisible = true
      this.$nextTick(() => {
        const panel = this.$refs.aiAssistantPanel
        if (panel && panel.focus) panel.focus()
        this.adjustAiTextareaHeight()
      })
    },
    /**
     * Bloom 活动任务专用头（header.vue nav_ai_banxue_btn）：每次打开或已打开时再点均为缩小模式；
     * 首次打开且尚未关闭过时为新对话 tab；关闭过后面板状态由 closeAiAssistant 保留，再点恢复。
     */
    openAiAssistantFromBloomHeader () {
      if (this.aiAssistantVisible) {
        this.aiAssistantCompact = true
        this.aiCompactSidebarOpen = false
        this.$nextTick(() => {
          const panel = this.$refs.aiAssistantPanel
          if (panel && panel.focus) panel.focus()
          this.adjustAiTextareaHeight()
        })
        return
      }
      this._openAiAssistantFromBloomHeaderCore()
    },
    /** 历史列表 hover 气泡全文（与列表项 preview 省略展示对应） */
    historyItemTooltipText (item) {
      if (!item) return ''
      const full = item.text != null ? String(item.text).trim() : ''
      if (full) return full
      return item.preview != null ? String(item.preview) : ''
    },
    /** 伴学助手：对话历史列表 DIALOGUE_LIST（无全屏 Loading），数据展示在左侧「历史对话」下方 */
    loadAiDialogueList (callback) {
      if (!this.isLogin) return
      this.$api.postNoLoading(
        'DIALOGUE_LIST',
        { pageSize: 50, startIndex: 0 },
        (res) => {
          const payload = res.data || {}
          const rows = payload.list || []
          const serverItems = rows.map((row) => {
            const title = row.title != null ? String(row.title) : ''
            let preview = title
            if (preview.length > 36) preview = preview.slice(0, 36) + '…'
            return {
              id: row.aiDialogueId,
              aiDialogueId: row.aiDialogueId,
              text: title,
              preview,
              fromServer: true
            }
          })
          const localOnly = this.aiChatHistory.filter((h) => !h.fromServer)
          this.aiChatHistory = [...localOnly, ...serverItems]
          typeof callback === 'function' && callback(serverItems)
        }
      )
    },
    /**
     * 将某条服务端历史会话提升到「服务端历史」区块的第一条（本地仅内存的项保持在其上方）。
     * 不切换选中、不清空消息区，避免打断等待 IM 等状态。
     * @param {number|string|null|undefined} aiDialogueId
     */
    pinAiChatHistoryServerItemToTop (aiDialogueId) {
      if (aiDialogueId == null || aiDialogueId === '') return
      const idStr = String(aiDialogueId)
      const idNum = Number(aiDialogueId)
      const list = this.aiChatHistory || []
      const match = (h) => {
        if (!h || !h.fromServer || h.aiDialogueId == null) return false
        return (
          String(h.aiDialogueId) === idStr ||
          (Number.isFinite(idNum) && Number(h.aiDialogueId) === idNum)
        )
      }
      const idx = list.findIndex(match)
      if (idx === -1) return
      const firstServerIdx = list.findIndex(h => h && h.fromServer)
      if (firstServerIdx === -1 || idx === firstServerIdx) return
      const item = list[idx]
      const next = list.slice()
      next.splice(idx, 1)
      next.splice(firstServerIdx, 0, item)
      this.aiChatHistory = next
    },
    /**
     * 伴学助手：某次对话的聊天记录 DIALOGUE_MSGLOG（postNoLoading，无全屏 Loading）
     * @param {{ pageSize?: number, startIndex?: number, aiDialogueId: number }} params 未传 pageSize/startIndex 时默认为 0
     * @param {function} [callback] 成功回调 (res) => void，res.data 含 totalCount、list（aiDialogueChatRecordId、userReq、agentRes）
     * @param {function} [errorCallback]
     * @param {function} [catchCallback]
     */
    loadAiDialogueMsgLog (params, callback, errorCallback, catchCallback) {
      if (!params || params.aiDialogueId === undefined || params.aiDialogueId === null) return
      const body = {
        pageSize: params.pageSize != null ? params.pageSize : 0,
        startIndex: params.startIndex != null ? params.startIndex : 0,
        aiDialogueId: params.aiDialogueId
      }
      return this.$api.postNoLoading('DIALOGUE_MSGLOG', body, callback, errorCallback, catchCallback)
    },
    /**
     * 伴学助手：发送用户消息 DIALOGUE_SEND（postNoLoading，无全屏 Loading）
     * @param {{ aiDialogueId?: number, content: string, intent?: number }} params
     *   intent：1 新对话 tab，2 推荐活动 tab，3 AI 生成选题 tab；历史会话等可不传
     * @param {function} [callback]
     * @param {function} [errorCallback]
     * @param {function} [catchCallback]
     */
    sendAiDialogueMessage (params, callback, errorCallback, catchCallback) {
      if (!params) return
      const content = String(params.content || '').trim()
      if (!content) return
      const body = { content }
      if (params.aiDialogueId !== undefined && params.aiDialogueId !== null && params.aiDialogueId !== '') {
        body.aiDialogueId = params.aiDialogueId
      }
      if (params.intent !== undefined && params.intent !== null && params.intent !== '') {
        const iv = Number(params.intent)
        if (Number.isFinite(iv)) body.intent = iv
      }
      return this.$api.postNoLoading('DIALOGUE_SEND', body, callback, errorCallback, catchCallback)
    },
    /** 历史会话分页：首次 10 条，触顶继续加载 10 条，直到 totalCount */
    loadMoreAiHistoryMsg (isInitial = false) {
      const selected = this.selectedHistoryItem
      if (!selected || !selected.fromServer || selected.aiDialogueId == null) return
      if (this.aiHistoryMsgInitialLoading || this.aiHistoryMsgLoadingMore) return
      if (!isInitial && !this.aiHistoryMsgHasMore) return

      const prevScrollTop = this.$refs.aiChatScroll ? this.$refs.aiChatScroll.scrollTop : 0
      const prevScrollHeight = this.$refs.aiChatScroll ? this.$refs.aiChatScroll.scrollHeight : 0
      if (isInitial) {
        this.aiHistoryMsgInitialLoading = true
        this.aiHistoryMsgStartIndex = 0
      } else {
        this.aiHistoryMsgLoadingMore = true
      }
      this.loadAiDialogueMsgLog(
        {
          pageSize: this.aiHistoryMsgPageSize,
          startIndex: this.aiHistoryMsgStartIndex,
          aiDialogueId: selected.aiDialogueId
        },
        (res) => {
          if (this.aiSelectedHistoryId !== selected.id) return
          const data = res.data || {}
          /* DIALOGUE_MSGLOG 的 list 已为时间正序（旧→新），与 H5 一致，勿 reverse */
          const rows = (data.list || []).slice().map((r) =>
            Object.assign({}, r, {
              agentResFromMsgLog: true,
              waitAgentRes: false
            })
          )
          const total = Number(data.totalCount) || 0
          this.aiHistoryMsgTotalCount = total
          this.aiHistoryMsgStartIndex = this.aiHistoryMsgStartIndex + rows.length
          this.aiHistoryMsgHasMore = this.aiHistoryMsgStartIndex < total && rows.length > 0
          if (isInitial) {
            this.aiHistoryMsgList = rows
            this._mergeAiAfterSendWaitRowIfNeeded(selected)
            this._mergeSnapshotDialogueIfAny(String(selected.aiDialogueId))
          } else {
            this.aiHistoryMsgList = [...rows, ...this.aiHistoryMsgList]
          }
          this.$nextTick(() => {
            const el = this.$refs.aiChatScroll
            if (!el) return
            if (isInitial) {
              el.scrollTop = el.scrollHeight
            } else {
              const nextScrollHeight = el.scrollHeight
              el.scrollTop = nextScrollHeight - prevScrollHeight + prevScrollTop
            }
          })
        },
        () => {},
        () => {}
      ).finally(() => {
        this.aiHistoryMsgInitialLoading = false
        this.aiHistoryMsgLoadingMore = false
      })
    },
    onAiChatScroll () {
      if (this.aiSidebarTab !== 'history') return
      const selected = this.selectedHistoryItem
      if (!selected || !selected.fromServer) return
      const el = this.$refs.aiChatScroll
      if (!el) return
      if (el.scrollTop <= 16) {
        this.loadMoreAiHistoryMsg(false)
      }
    },
    closeAiAssistant () {
      this.aiAssistantVisible = false
      /** 关闭后再次打开头部入口：不再按随机提示词跳 tab，保持关闭前状态 */
      this.aiAssistantHeaderEntryTabPending = false
    },
    onAiAssistantEsc () {
      if (this.aiAssistantCompact && this.aiCompactSidebarOpen) {
        this.aiCompactSidebarOpen = false
        return
      }
      this.closeAiAssistant()
    },
    onAiAssistantShrink () {
      this.aiAssistantCompact = !this.aiAssistantCompact
      if (!this.aiAssistantCompact) {
        this.aiCompactSidebarOpen = false
      }
    },
    toggleAiCompactNav () {
      if (!this.aiAssistantCompact) return
      this.aiCompactSidebarOpen = !this.aiCompactSidebarOpen
    },
    closeAiCompactNav () {
      this.aiCompactSidebarOpen = false
    },
    /**
     * 伴学快捷知识点：从池中无放回随机取 3 个下标（每次进入新对话时调用）
     */
    shuffleAiQuickChipsPick () {
      const pool = AI_QUICK_KNOWLEDGE_PROMPTS
      const n = pool.length
      if (!n) {
        this.aiQuickChipsPickIds = []
        return
      }
      const idx = Array.from({ length: n }, (_, i) => i)
      for (let i = n - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const t = idx[i]
        idx[i] = idx[j]
        idx[j] = t
      }
      this.aiQuickChipsPickIds = idx.slice(0, Math.min(3, n))
    },
    chipTitleDisplay (chip) {
      if (!chip) return ''
      return this.aiAssistantCompact && chip.titleCompact ? chip.titleCompact : chip.title
    },
    chipHintDisplay (chip) {
      if (!chip) return ''
      if (this.aiAssistantCompact && chip.hintCompact) return chip.hintCompact
      return chip.hint || ''
    },
    setAiInput (text) {
      if (this.aiAssistantTextareaDisabled) return
      this.aiInputText = text
      this.$nextTick(() => this.adjustAiTextareaHeight())
    },
    /** 单行默认高度，随内容增高，最多 5 行 */
    adjustAiTextareaHeight () {
      const el = this.$refs.aiInputField
      if (!el) return
      el.style.height = 'auto'
      const cs = window.getComputedStyle(el)
      const lh = parseFloat(cs.lineHeight)
      const lineHeight = Number.isFinite(lh) && lh > 0 ? lh : parseFloat(cs.fontSize) * 1.5
      const pt = parseFloat(cs.paddingTop) || 0
      const pb = parseFloat(cs.paddingBottom) || 0
      const minH = lineHeight + pt + pb
      const maxH = lineHeight * 5 + pt + pb
      const sh = el.scrollHeight
      const h = Math.min(Math.max(sh, minH), maxH)
      el.style.height = `${h}px`
      el.style.overflowY = sh > maxH ? 'auto' : 'hidden'
    },
    /**
     * DIALOGUE_SEND 失败或网络异常时，移除本次乐观插入的待同步用户消息行
     * @param {string|null|undefined} aiDialogueChatRecordId
     */
    removeAiHistoryOptimisticSendRowIfPending (aiDialogueChatRecordId) {
      if (!aiDialogueChatRecordId) return
      const idx = this.aiHistoryMsgList.findIndex(
        r => r && r.aiDialogueChatRecordId === aiDialogueChatRecordId && r.__pending
      )
      if (idx !== -1) this.aiHistoryMsgList.splice(idx, 1)
    },
    /**
     * 历史会话内 DIALOGUE_SEND 成功后：追加一轮问答占位，agentRes 等 IM 750（与 bloom-H5 appendHistoryChatTurnAfterSend 对齐）
     */
    appendAiHistoryTurnAfterSend (userText, sendData) {
      this.ensureAiIm750RuntimeState()
      /** 新一轮发送：清除「停止时尚无 recordId」的 pending，避免误拦下一轮首条 IM */
      this._im750AbortPending = null
      const d = sendData && typeof sendData === 'object' ? sendData : {}
      const pendingId =
        d.chatMsgId != null
          ? d.chatMsgId
          : d.msgId != null
            ? d.msgId
            : d.dialogueMsgId != null
              ? d.dialogueMsgId
              : null
      const rec =
        d.aiDialogueChatRecordId != null && d.aiDialogueChatRecordId !== ''
          ? d.aiDialogueChatRecordId
          : null
      const localId =
        rec != null
          ? rec
          : `local-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
      this.aiHistoryMsgList.push({
        aiDialogueChatRecordId: localId,
        userReq: userText,
        agentRes: '',
        __pending: true,
        waitAgentRes: true,
        im750WaitStartedAt: Date.now(),
        im750ThinkingDismissed: false,
        agentResFromMsgLog: false,
        im750ErrorTip: '',
        _pendingChatMsgId: pendingId != null && pendingId !== '' ? String(pendingId) : null
      })
      this.$nextTick(() => {
        const el = this.$refs.aiChatScroll
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    /**
     * 新建会话发送成功并已选中会话、MSGLOG 首屏写入 aiHistoryMsgList 后：若最后一行即本轮用户问且无 agent，则就地置 waitAgentRes；否则 append
     */
    _mergeAiAfterSendWaitRowIfNeeded (selected) {
      const pend = this._aiAfterSendNeedWaitRow
      if (!pend || !selected || !selected.fromServer) return
      if (String(pend.dialogueId) !== String(selected.aiDialogueId)) {
        this._aiAfterSendNeedWaitRow = null
        return
      }
      this._aiAfterSendNeedWaitRow = null
      const list = this.aiHistoryMsgList
      const lastIdx = list.length - 1
      const last = lastIdx >= 0 ? list[lastIdx] : null
      const ut = String(pend.userText || '').trim()
      const lastUser = last && String(last.userReq || '').trim()
      const agentEmpty = !last || !String(last.agentRes || '').trim()
      if (last && lastUser === ut && agentEmpty) {
        const d = pend.sendData || {}
        const rec =
          d.aiDialogueChatRecordId != null && d.aiDialogueChatRecordId !== ''
            ? d.aiDialogueChatRecordId
            : last.aiDialogueChatRecordId
        const pendingId =
          d.chatMsgId != null
            ? d.chatMsgId
            : d.msgId != null
              ? d.msgId
              : d.dialogueMsgId != null
                ? d.dialogueMsgId
                : null
        this.$set(this.aiHistoryMsgList, lastIdx, {
          ...last,
          waitAgentRes: true,
          __pending: true,
          im750ThinkingDismissed: false,
          im750WaitStartedAt: last.im750WaitStartedAt != null ? last.im750WaitStartedAt : Date.now(),
          im750ErrorTip: last.im750ErrorTip || '',
          agentResFromMsgLog: last.agentResFromMsgLog,
          ...(rec != null && rec !== '' ? { aiDialogueChatRecordId: rec } : {}),
          _pendingChatMsgId:
            pendingId != null && pendingId !== ''
              ? String(pendingId)
              : (last._pendingChatMsgId != null ? last._pendingChatMsgId : null)
        })
      } else {
        this.appendAiHistoryTurnAfterSend(pend.userText, pend.sendData)
      }
      this.$nextTick(() => {
        const el = this.$refs.aiChatScroll
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    /**
     * Enter 发送；Shift+Enter 换行；输入法组字过程中不拦截
     * @param {KeyboardEvent} e
     */
    onAiSendOrStop () {
      if (this._aiSendOrStopLead) {
        this._aiSendOrStopLead()
      } else {
        if (this.aiSendLoading) return
        if (this.aiAssistantWaitingImReply) {
          this.stopAiAssistantGeneration()
          return
        }
        this.onAiSend()
      }
    },
    /**
     * 用户停止本轮生成：丢弃后续同 recordId 的 IM，立即结束 waitAgentRes。
     */
    stopAiAssistantGeneration () {
      if (!this.aiAssistantWaitingImReply) return
      const list = this.aiHistoryMsgList
      const waitIndices = []
      for (let i = 0; i < list.length; i++) {
        const r = list[i]
        if (r && r.waitAgentRes) waitIndices.push(i)
      }
      if (waitIndices.length === 0) return

      const primaryIdx = Math.max(...waitIndices)
      const row = list[primaryIdx]
      const rid = row.aiDialogueChatRecordId != null ? String(row.aiDialogueChatRecordId) : ''
      const isLocalRid = rid && String(rid).startsWith('local-')
      const dialogueIdStr =
        this.aiCurrentDialogueId != null ? String(this.aiCurrentDialogueId) : ''

      if (!this._im750AbortedRecordIds) this._im750AbortedRecordIds = new Set()
      for (const j of waitIndices) {
        const wr = list[j]
        const wRid =
          wr && wr.aiDialogueChatRecordId != null
            ? String(wr.aiDialogueChatRecordId)
            : ''
        if (wRid && !String(wRid).startsWith('local-')) {
          this._im750AbortedRecordIds.add(wRid)
          removeIm750RecordBuffer(wRid)
        }
      }

      if (rid && !isLocalRid) {
        this._im750AbortPending = null
      } else {
        this._im750AbortPending = {
          dialogueId: dialogueIdStr,
          userReq: String(row.userReq || '').trim()
        }
      }

      const seenFirst =
        rid &&
        this._aiIm750FirstPacketSeen &&
        this._aiIm750FirstPacketSeen[rid] === true
      const agentEmpty = !String(row.agentRes || '').trim()
      const noContentYet = agentEmpty && !seenFirst

      const primaryPatch = {
        ...row,
        waitAgentRes: false,
        _asaStreamDone: true,
        _asaUserAborted: true,
        _asaStoppedWithNoContent: noContentYet,
        im750WaitStartedAt: undefined,
        im750ThinkingDismissed: true,
        __pending: false
      }

      const seenRids = []
      for (const j of waitIndices) {
        const wr = list[j]
        const sr =
          wr && wr.aiDialogueChatRecordId != null
            ? String(wr.aiDialogueChatRecordId)
            : ''
        if (sr) seenRids.push(sr)
      }

      for (const j of waitIndices) {
        if (j === primaryIdx) continue
        const other = list[j]
        if (!other) continue
        this.$set(list, j, {
          ...other,
          waitAgentRes: false,
          _asaStreamDone: true,
          _asaUserAborted: true,
          im750WaitStartedAt: undefined,
          im750ThinkingDismissed: true,
          __pending: false
        })
      }
      this.$set(list, primaryIdx, primaryPatch)

      if (this._aiIm750FirstPacketSeen && typeof this._aiIm750FirstPacketSeen === 'object') {
        for (const sr of seenRids) {
          try {
            delete this._aiIm750FirstPacketSeen[sr]
          } catch (e) {}
        }
      }
      for (const j of waitIndices) {
        const pr = list[j]
        if (!pr || pr.aiDialogueChatRecordId == null || pr.aiDialogueChatRecordId === '') continue
        const prid = String(pr.aiDialogueChatRecordId)
        if (prid.startsWith('local-')) continue
        this._syncStoppedRowToAiDialogueStreamCache(pr)
      }
    },
    _syncStoppedRowToAiDialogueStreamCache (patchRow) {
      const d = this.aiCurrentDialogueId
      if (d == null || d === '') return
      const entry = this.aiDialogueStreamCache[String(d)]
      if (!entry || !Array.isArray(entry.rows)) return
      const targetRid =
        patchRow.aiDialogueChatRecordId != null ? String(patchRow.aiDialogueChatRecordId) : ''
      if (!targetRid) return
      for (let i = 0; i < entry.rows.length; i++) {
        const r = entry.rows[i]
        if (
          r &&
          r.waitAgentRes &&
          String(r.aiDialogueChatRecordId) === targetRid
        ) {
          this.$set(entry.rows, i, { ...r, ...patchRow })
          return
        }
      }
    },
    onAiInputKeydown (e) {
      if (e.key !== 'Enter') return
      if (e.isComposing || e.keyCode === 229) return
      if (e.shiftKey) return
      e.preventDefault()
      if (this._aiSendLead) {
        this._aiSendLead()
      } else {
        this.onAiSend()
      }
    },
    onAiSend () {
      const raw = String(this.aiInputText || '').trim()
      if (!raw || this.aiSendLoading || this.aiAssistantWaitingImReply) return
      const selected = this.selectedHistoryItem
      const isBaseEntryTab = this.aiSidebarTab === 'newChat' || this.aiSidebarTab === 'recommend' || this.aiSidebarTab === 'topic'
      let sendIntent
      if (this.aiSidebarTab === 'newChat') sendIntent = 1
      else if (this.aiSidebarTab === 'recommend') sendIntent = 2
      else if (this.aiSidebarTab === 'topic') sendIntent = 3
      const currentDialogueId = (!isBaseEntryTab && this.aiSidebarTab === 'history' && selected && selected.fromServer) ? selected.aiDialogueId : null
      /** 仅在 DIALOGUE_SEND 成功后再进入 waitAgentRes / 锁定等 IM，避免接口失败仍占位 */
      this.aiSendLoading = true
      this.sendAiDialogueMessage(
        {
          aiDialogueId: currentDialogueId,
          content: raw,
          ...(sendIntent != null ? { intent: sendIntent } : {})
        },
        (res) => {
          const data = res.data || {}
          const returnedDialogueId = data.aiDialogueId
          this.aiInputText = ''
          this.$nextTick(() => this.adjustAiTextareaHeight())
          if (!currentDialogueId && returnedDialogueId != null) {
            this.aiEntrySendPending = false
            this.aiEntrySendOriginTab = null
            this.aiCurrentDialogueId = String(returnedDialogueId)
            this._aiAfterSendNeedWaitRow = {
              dialogueId: String(returnedDialogueId),
              userText: raw,
              sendData: data
            }
            this.loadAiDialogueList((serverItems) => {
              const target = (serverItems || []).find(item => item.aiDialogueId === returnedDialogueId)
              if (target) {
                this.selectAiHistoryItem(target)
              } else {
                this._aiAfterSendNeedWaitRow = null
              }
            })
            return
          }
          if (currentDialogueId != null) {
            this.appendAiHistoryTurnAfterSend(raw, data)
            this.pinAiChatHistoryServerItemToTop(currentDialogueId)
            return
          }
          if (currentDialogueId == null) {
            this.loadAiDialogueList()
          }
        },
        () => {
          this._aiAfterSendNeedWaitRow = null
          this.rollBackAiEntrySendIfNeeded()
          /** postNoLoading 在 code≠0 时可能不 settle Promise，finally 不会执行 */
          this.aiSendLoading = false
        },
        () => {
          this._aiAfterSendNeedWaitRow = null
          this.rollBackAiEntrySendIfNeeded()
        }
      ).finally(() => {
        this.aiSendLoading = false
      })
    },
    /**
     * 从 newChat/recommend/topic 首条发送失败：清空主区占位并回到原 tab
     */
    rollBackAiEntrySendIfNeeded () {
      if (!this.aiEntrySendPending && this.aiEntrySendOriginTab == null) return
      this.aiEntrySendPending = false
      this.aiHistoryMsgList = []
      const tab = this.aiEntrySendOriginTab
      this.aiEntrySendOriginTab = null
      if (tab != null) {
        this.setAiSidebarTab(tab)
      }
    },
    /**
     * 从接口/IM 的 agentRes（字符串或已解析对象）得到活动卡片数据
     * @param {string|object} raw
     * @returns {object|null}
     */
    resolveContestCardFromAgentRes (raw) {
      const { parts } = this.buildAgentResContestLayout(raw)
      for (let i = 0; i < parts.length; i++) {
        const p = parts[i]
        if (p.type === 'cards' && p.cards && p.cards.length) return p.cards[0]
      }
      return null
    },
    /**
     * 将围栏内 JSON 里 contestId、seasonId 的裸数字改为带引号的字符串再 parse，避免超长整型被 JSON 转成 Number 丢精度
     * @param {string} jsonStr
     * @returns {string}
     */
    sanitizeContestJsonIdNumbers (jsonStr) {
      return String(jsonStr)
        .replace(/^\uFEFF/, '')
        .replace(/"contestId"\s*:\s*(-?\d+)/g, '"contestId":"$1"')
        .replace(/"seasonId"\s*:\s*(-?\d+)/g, '"seasonId":"$1"')
    },
    /**
     * 保证卡片上 contestId、seasonId 为字符串（展示与跳转 URL 均不丢精度）
     * @param {object} card
     * @returns {object}
     */
    normalizeContestCardIds (card) {
      if (!card || typeof card !== 'object') return card
      const out = Object.assign({}, card)
      if (out.contestId != null) out.contestId = String(out.contestId)
      if (out.seasonId != null) out.seasonId = String(out.seasonId)
      return out
    },
    /**
     * 围栏内 JSON 解析为活动对象
     * @param {string} jsonStr
     * @returns {object|null}
     */
    parseContestJsonFromInner (jsonStr) {
      if (jsonStr == null || String(jsonStr).trim() === '') return null
      try {
        let prepped = this.sanitizeContestJsonIdNumbers(String(jsonStr).trim())
        let obj = JSON.parse(prepped)
        if (typeof obj === 'string') {
          try {
            prepped = this.sanitizeContestJsonIdNumbers(String(obj).trim())
            obj = JSON.parse(prepped)
          } catch (e2) {
            return null
          }
        }
        if (obj && obj.contestId != null) return this.normalizeContestCardIds(obj)
      } catch (e) {
        return null
      }
      return null
    },
    /**
     * 根节点稳定键（用于合并多段 IM 的 topicTree，避免同一份整树重复 concat）
     */
    topicTreeRootKey (node, index) {
      if (!node || typeof node !== 'object') return `i:${index}`
      if (node.labelId != null && String(node.labelId) !== '') return `id:${String(node.labelId)}`
      return `p:${index}:${String(node.label != null ? node.label : '')}`
    },
    /**
     * 合并多段 ```topicTree```：整树重复推送时取最新一份；分批发列时按根去重追加
     * @param {Array} existing
     * @param {Array} chunk
     * @returns {Array}
     */
    mergeTopicTreeChunks (existing, chunk) {
      if (!Array.isArray(chunk) || chunk.length === 0) return (existing || []).slice()
      const ex = Array.isArray(existing) ? existing.slice() : []
      if (ex.length === 0) return chunk.slice()
      const sig = (arr) =>
        arr.map((n, i) => this.topicTreeRootKey(n, i)).join('|')
      const sEx = sig(ex)
      const sCh = sig(chunk)
      /* 同结构同列数：视为同一份树刷新，只保留最新 */
      if (ex.length === chunk.length && sEx === sCh) return chunk.slice()
      /* 新片段是「更完整」的快照：前缀与已有根顺序一致则整表替换 */
      if (chunk.length >= ex.length && ex.length > 0) {
        const prefix = chunk.slice(0, ex.length)
        if (sig(prefix) === sEx) return chunk.slice()
      }
      const seen = new Set(ex.map((n, i) => this.topicTreeRootKey(n, i)))
      const toAdd = []
      for (let i = 0; i < chunk.length; i++) {
        const k = this.topicTreeRootKey(chunk[i], ex.length + i)
        if (seen.has(k)) continue
        seen.add(k)
        toAdd.push(chunk[i])
      }
      if (toAdd.length === 0) return chunk.length >= ex.length ? chunk.slice() : ex.slice()
      return ex.concat(toAdd)
    },
    /**
     * topicList 多段合并：同长度同标题序列则取最新，否则按 topicName 去重追加
     */
    mergeTopicListChunks (existing, chunk) {
      if (!Array.isArray(chunk) || chunk.length === 0) return (existing || []).slice()
      const ex = Array.isArray(existing) ? existing.slice() : []
      if (ex.length === 0) return chunk.slice()
      const key = (row) =>
        String(row && row.topicName != null ? row.topicName : '') +
        '|' +
        String(row && row.topicDesc != null ? row.topicDesc : '')
      const sig = (arr) => arr.map(key).join('§')
      if (ex.length === chunk.length && sig(ex) === sig(chunk)) return chunk.slice()
      const seen = new Set(ex.map(key))
      const toAdd = chunk.filter((r) => {
        const k = key(r)
        if (seen.has(k)) return false
        seen.add(k)
        return true
      })
      if (toAdd.length === 0) return chunk.length >= ex.length ? chunk.slice() : ex.slice()
      return ex.concat(toAdd)
    },
    /**
     * 解析 ```topicTree``` 围栏内 JSON（与首页 COMMON_AI_TOPIC_GENERATE 返回的 topicTree 结构一致）
     * @param {string} inner
     * @returns {Array}
     */
    parseTopicTreeFenceInner (inner) {
      if (inner == null || String(inner).trim() === '') return []
      try {
        let o = JSON.parse(String(inner).trim().replace(/^\uFEFF/, ''))
        if (typeof o === 'string') o = JSON.parse(o)
        if (Array.isArray(o)) return o
        if (o && Array.isArray(o.topicTree)) return o.topicTree
        /* 单条 IM 常发一列根节点对象，与数组三列拼成完整树 */
        if (o && typeof o === 'object' && (o.label != null || o.value != null || o.children != null || o.childList != null || o.nodes != null)) {
          return [o]
        }
      } catch (e) {
        return []
      }
      return []
    },
    /**
     * 解析 ```topicNameListStr``` 围栏内 JSON（与 topicList 一致，供选题说明区展示）
     * @param {string} inner
     * @returns {Array}
     */
    parseTopicNameListStrFenceInner (inner) {
      if (inner == null || String(inner).trim() === '') return []
      try {
        let o = JSON.parse(String(inner).trim().replace(/^\uFEFF/, ''))
        if (typeof o === 'string') o = JSON.parse(o)
        if (Array.isArray(o)) return o
        if (o && Array.isArray(o.topicList)) return o.topicList
        if (o && typeof o === 'object' && (o.topicName != null || o.topicDesc != null || o.topicRelationNodeIds != null)) {
          return [o]
        }
      } catch (e) {
        return []
      }
      return []
    },
    /**
     * 将 agentRes 拆成顺序片段：文案 + ```contestFence``` 卡片组 + ```topicTree```/```topicNameListStr``` 选题区（保留围栏间文案）。
     * 文案段内 GFM 代码围栏（```js 等非上述三种关键字）由 AiStreamingText 的 markdown-it fence 渲染，与业务围栏互斥。
     * @param {string|object} raw
     * @returns {{ parts: Array }}
     */
    buildAgentResContestLayout (raw) {
      if (raw == null) return { parts: [] }
      if (typeof raw === 'object' && !Array.isArray(raw) && raw.contestId != null) {
        return { parts: [{ type: 'cards', cards: [this.normalizeContestCardIds(raw)] }] }
      }
      const fullText = typeof raw === 'string' ? raw : String(raw)
      const s = fullText.replace(/\r\n/g, '\n')
      const trimmed = s.trim()
      if (!trimmed) return { parts: [] }

      const fenceRe = /```\s*(contestFence|topicTree|topicNameListStr)\s*\n?([\s\S]*?)\s*```/gi
      const rawPieces = []
      let last = 0
      let m
      while ((m = fenceRe.exec(s)) !== null) {
        const pre = s.slice(last, m.index)
        if (pre.trim()) rawPieces.push({ t: 'text', v: pre.trim() })
        const kind = String(m[1]).toLowerCase()
        const inner = m[2].trim()
        if (kind === 'contestfence') {
          const card = this.parseContestJsonFromInner(inner)
          if (card) rawPieces.push({ t: 'card', v: card })
        } else if (kind === 'topictree') {
          const tree = this.parseTopicTreeFenceInner(inner)
          if (tree.length) rawPieces.push({ t: 'topicTree', v: tree })
        } else if (kind === 'topicnameliststr') {
          const list = this.parseTopicNameListStrFenceInner(inner)
          if (list.length) rawPieces.push({ t: 'topicList', v: list })
        }
        last = m.index + m[0].length
      }
      const tail = s.slice(last)
      if (tail.trim()) rawPieces.push({ t: 'text', v: tail.trim() })

      if (!rawPieces.length) {
        const card = this.parseContestFence(trimmed)
        if (card) return { parts: [{ type: 'cards', cards: [card] }] }
        return { parts: [{ type: 'text', text: trimmed }] }
      }

      const parts = []
      let cardBuf = []
      let topicMerge = null

      const flushCards = () => {
        if (cardBuf.length) {
          parts.push({ type: 'cards', cards: cardBuf.slice() })
          cardBuf = []
        }
      }
      const flushTopicMerge = () => {
        if (topicMerge && (topicMerge.tree.length || topicMerge.list.length)) {
          parts.push({
            type: 'topicFence',
            topicTree: topicMerge.tree.length ? topicMerge.tree : [],
            topicList: topicMerge.list.length ? topicMerge.list : []
          })
          topicMerge = null
        }
      }
      for (let i = 0; i < rawPieces.length; i++) {
        const p = rawPieces[i]
        if (p.t === 'text') {
          flushCards()
          /* 仅换行/空白夹在 topic 围栏之间时不切断合并，避免树与 topicNameListStr 拆成两块导致下方文案丢失 */
          if (String(p.v).trim() === '') {
            /* skip */
          } else {
            flushTopicMerge()
            parts.push({ type: 'text', text: p.v })
          }
        } else if (p.t === 'card') {
          flushTopicMerge()
          cardBuf.push(p.v)
        } else if (p.t === 'topicTree') {
          flushCards()
          if (!topicMerge) topicMerge = { tree: [], list: [] }
          const chunk = Array.isArray(p.v) ? p.v : []
          topicMerge.tree = this.mergeTopicTreeChunks(topicMerge.tree, chunk)
        } else if (p.t === 'topicList') {
          flushCards()
          if (!topicMerge) topicMerge = { tree: [], list: [] }
          const chunk = Array.isArray(p.v) ? p.v : []
          topicMerge.list = this.mergeTopicListChunks(topicMerge.list, chunk)
        }
      }
      flushCards()
      flushTopicMerge()
      return { parts: this.squashAdjacentTopicFences(parts) }
    },
    /**
     * 将连续多条 topicFence 片段合成一块（例如树与 topicNameListStr 中间曾插入空 text 仍被拆成两段时）
     */
    squashAdjacentTopicFences (parts) {
      if (!Array.isArray(parts) || !parts.length) return parts
      const out = []
      for (let i = 0; i < parts.length; i++) {
        const p = parts[i]
        if (p.type === 'topicFence') {
          const last = out[out.length - 1]
          if (last && last.type === 'topicFence') {
            last.topicTree = this.mergeTopicTreeChunks(last.topicTree || [], p.topicTree || [])
            last.topicList = this.mergeTopicListChunks(last.topicList || [], p.topicList || [])
            continue
          }
          out.push({
            type: 'topicFence',
            topicTree: (p.topicTree || []).slice(),
            topicList: (p.topicList || []).slice()
          })
        } else {
          out.push(p)
        }
      }
      return out
    },
    /**
     * 解析 ```contestFence ... ``` 或裸 JSON（无围栏时无前后拆分）
     * @param {string} text
     * @returns {object|null}
     */
    parseContestFence (text) {
      if (text == null || typeof text !== 'string') return null
      let s = text.trim().replace(/\r\n/g, '\n')
      if (!s) return null

      let jsonStr = null
      const fenceRe = /```\s*contestFence\s*\n?([\s\S]*?)\s*```/i
      const fenceMatch = s.match(fenceRe)
      if (fenceMatch && fenceMatch[1]) {
        jsonStr = fenceMatch[1].trim()
      }

      if (!jsonStr && /^\s*\{/.test(s)) {
        jsonStr = s
      }

      if (!jsonStr && /"contestId"\s*:/.test(s)) {
        const i0 = s.indexOf('{')
        const i1 = s.lastIndexOf('}')
        if (i0 !== -1 && i1 > i0) {
          jsonStr = s.slice(i0, i1 + 1).trim()
        }
      }

      if (!jsonStr) return null
      return this.parseContestJsonFromInner(jsonStr)
    },
    formatContestDateMs (ms) {
      const n = Number(ms)
      if (!Number.isFinite(n)) return ''
      const d = new Date(n)
      const y = d.getFullYear()
      const mo = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}/${mo}/${day}`
    },
    formatContestEnterRange (card) {
      if (!card) return '—'
      const a = this.formatContestDateMs(card.enterStartTime)
      const b = this.formatContestDateMs(card.enterEndTime)
      if (!a && !b) return '—'
      if (!a) return b
      if (!b) return a
      return `${a} - ${b}`
    },
    formatContestGradeRange (card) {
      if (!card) return '—'
      const lo = card.minGrade != null ? String(card.minGrade).trim() : ''
      const hi = card.maxGrade != null ? String(card.maxGrade).trim() : ''
      if (lo && hi) return `${lo}-${hi}`
      return lo || hi || '—'
    },
    normalizeContestRating (r) {
      const x = Math.round(Number(r))
      if (!Number.isFinite(x)) return 0
      return Math.min(5, Math.max(0, x))
    },
    contestRegistrationBadge (card) {
      const now = Date.now()
      const end = Number(card && card.enterEndTime)
      const start = Number(card && card.enterStartTime)
      if (Number.isFinite(end) && now > end) {
        return { text: this.$t('aiStudyBuddy.badgeEnded'), mod: 'end' }
      }
      if (Number.isFinite(start) && now < start) {
        return { text: this.$t('aiStudyBuddy.badgePending'), mod: 'pending' }
      }
      return { text: this.$t('aiStudyBuddy.badgeOpen'), mod: 'open' }
    },
    aiContestRatingAria (card) {
      const rating = this.normalizeContestRating(card && card.ratNum)
      return this.$t('aiStudyBuddy.ratingAria', { rating })
    },
    /** 与 bloom-H5 asa-recommend-card titleText 一致：nameEn + nameCn（trim、中间无空格） */
    aiContestCardTitleText (card) {
      if (!card) return '—'
      const en = String(card.nameEn != null ? card.nameEn : '').trim()
      const cn = String(card.nameCn != null ? card.nameCn : '').trim()
      const s = en + cn
      return s || '—'
    },
    /**
     * 活动详情跳转：与首页 index-public/activity-list.vue 的 topage 相同（新窗口、hash、GameData 路径与 query）
     * @param {object} card 推荐活动卡片（contestId、seasonId；路径段使用 nameEn，与首页活动列表一致）
     */
    openAiContestDetailFromCard (card) {
      if (!card || card.contestId == null) return
      const nameEn =
        card.nameEn != null && String(card.nameEn).trim() !== ''
          ? String(card.nameEn).trim()
          : 'x'
      this.$utils.CzcTrackEvent(this.$route.name, '伴学助手推荐活动', card.nameEn)
      const cid = String(card.contestId)
      const sid = card.seasonId != null ? String(card.seasonId) : ''
      let url = window.location.href.split('/#/')[0] + '/#'
      url = url + `/GameData/${nameEn}?contestId=${cid}&seasonId=${sid}`
      window.open(url)
    },
    /**
     * 同 aiDialogueChatRecordId 时从底部向上找；跳过「已落库且已结束」的历史行，避免结束包误合并到首条同 id 的 MSGLOG 行、底部流式行仍 wait（与 bloom-H5 findImRowIndexByRecordId 一致）。
     */
    findAiHistoryRowIndexByRecordIdForIm750 (rowList, recordId) {
      const rid = recordId != null ? String(recordId).trim() : ''
      if (!rid) return -1
      const list = Array.isArray(rowList) ? rowList : []
      let lastWaiting = -1
      let lastNonLog = -1
      let lastAny = -1
      for (let i = list.length - 1; i >= 0; i--) {
        const row = list[i]
        if (!row || String(row.aiDialogueChatRecordId || '').trim() !== rid) continue
        const frozenHistory =
          row.agentResFromMsgLog === true && row.waitAgentRes !== true
        if (frozenHistory) continue
        if (lastAny < 0) lastAny = i
        if (!row.agentResFromMsgLog && lastNonLog < 0) lastNonLog = i
        if (row.waitAgentRes && lastWaiting < 0) lastWaiting = i
      }
      if (lastWaiting >= 0) return lastWaiting
      if (lastNonLog >= 0) return lastNonLog
      return lastAny
    },
    /**
     * 占位行仍为 local- 时，首条 IM 仅为 complete 带服务端 recordId，按 id 无法命中；合并到当前仍在等待的占位行（与 H5 findIm750AttachRowIndexForNewServerRecord 一致）。
     */
    findIm750AttachRowIndexForNewServerRecord (rowList, serverRid) {
      const srv = serverRid != null ? String(serverRid).trim() : ''
      if (!srv) return -1
      const list = Array.isArray(rowList) ? rowList : []
      for (let i = list.length - 1; i >= 0; i--) {
        const row = list[i]
        if (!row || !row.waitAgentRes) continue
        const frozenHistory =
          row.agentResFromMsgLog === true && row.waitAgentRes !== true
        if (frozenHistory) continue
        const ridRow = String(row.aiDialogueChatRecordId || '').trim()
        if (ridRow === srv) return -1
        const attachable =
          !ridRow ||
          row.__pending === true ||
          /^local-/i.test(ridRow) ||
          /^temp-/i.test(ridRow)
        if (!attachable) continue
        return i
      }
      return -1
    },
    resolveAiHistoryRowIndexForIm750Incoming (rowList, recordId) {
      const primary = this.findAiHistoryRowIndexByRecordIdForIm750(rowList, recordId)
      if (primary > -1) return primary
      return this.findIm750AttachRowIndexForNewServerRecord(rowList, recordId)
    },
    /** 与 bloom-H5 isIm750AnswerComplete 一致 */
    isIm750AnswerComplete (msg) {
      if (!msg || typeof msg !== 'object') {
        return false
      }
      const truthy = (v) =>
        v === true || v === 'true' || v === 1 || v === '1'
      if (truthy(msg.isComplete)) {
        return true
      }
      const kind = String(msg.kind || '').toLowerCase()
      if (kind === 'complete') {
        return true
      }
      if (truthy(msg.finished) || truthy(msg.ended)) {
        return true
      }
      let md = msg.messageData
      if (md != null && typeof md === 'string') {
        const t = md.trim()
        if (t.startsWith('{') || t.startsWith('[')) {
          try {
            md = JSON.parse(t)
          } catch (e) {
            md = null
          }
        } else if (t !== '') {
          try {
            md = JSON.parse(t)
          } catch (e) {
            md = null
          }
        } else {
          md = null
        }
      }
      if (md && typeof md === 'object' && !Array.isArray(md)) {
        if (truthy(md.isComplete)) {
          return true
        }
        if (String(md.kind || '').toLowerCase() === 'complete') {
          return true
        }
        if (truthy(md.finished) || truthy(md.ended)) {
          return true
        }
      }
      return false
    },
    /** 保证首包 map 与 aiHistoryMsgList 可安全 $set，避免 undefined[recordId] */
    ensureAiIm750RuntimeState () {
      if (!this._aiIm750FirstPacketSeen || typeof this._aiIm750FirstPacketSeen !== 'object') {
        this._aiIm750FirstPacketSeen = {}
      }
      if (!Array.isArray(this.aiHistoryMsgList)) {
        this.aiHistoryMsgList = []
      }
    },
    /**
     * 与 bloom-H5 clearWaitAgentResAfter750Complete 一致（列表字段为 aiHistoryMsgList）
     * @param {Array|undefined} listOverride 非当前主列表时传入（如 aiDialogueStreamCache 内 rows）
     */
    clearWaitAgentResAfter750Complete (recordId, msgUserReq, listOverride) {
      if (listOverride == null) {
        this.ensureAiIm750RuntimeState()
      } else if (!Array.isArray(listOverride)) {
        return
      }
      const rid = recordId != null && recordId !== '' ? String(recordId).trim() : ''
      const list = listOverride != null ? listOverride : this.aiHistoryMsgList
      const preserveIm750Tip = (r) => {
        const t = r && r.im750ErrorTip != null ? String(r.im750ErrorTip).trim() : ''
        return t ? r.im750ErrorTip : ''
      }
      if (rid) {
        let idx = -1
        for (let j = list.length - 1; j >= 0; j--) {
          const r = list[j]
          if (r && r.waitAgentRes && String(r.aiDialogueChatRecordId || '').trim() === rid) {
            idx = j
            break
          }
        }
        if (idx > -1) {
          const r = list[idx]
          this.$set(list, idx, {
            ...r,
            waitAgentRes: false,
            _asaStreamDone: true,
            im750WaitStartedAt: undefined,
            im750ErrorTip: preserveIm750Tip(r)
          })
          if (!list.some((m) => m && m.waitAgentRes)) {
            return
          }
        }
      }
      const u = msgUserReq != null ? String(msgUserReq) : ''
      if (u) {
        for (let i = list.length - 1; i >= 0; i--) {
          const r = list[i]
          if (r && r.waitAgentRes && String(r.userReq || '') === u) {
            this.$set(list, i, {
              ...r,
              waitAgentRes: false,
              _asaStreamDone: true,
              im750WaitStartedAt: undefined,
              im750ErrorTip: preserveIm750Tip(r)
            })
            break
          }
        }
        if (!list.some((m) => m && m.waitAgentRes)) {
          return
        }
      }
      for (let i = list.length - 1; i >= 0; i--) {
        const r = list[i]
        if (r && r.waitAgentRes) {
          this.$set(list, i, {
            ...r,
            waitAgentRes: false,
            _asaStreamDone: true,
            im750WaitStartedAt: undefined,
            im750ErrorTip: preserveIm750Tip(r)
          })
          break
        }
      }
    },
    /**
     * 结束标识已到达后，强制解除同 recordId 下仍残留的 wait（与 bloom-H5 _im750SweepClearWaitForAnswerComplete 一致）。
     */
    _im750SweepClearWaitForAnswerComplete (list, ridStr) {
      const rid = ridStr != null ? String(ridStr).trim() : ''
      if (!rid || !Array.isArray(list)) return
      for (let i = list.length - 1; i >= 0; i--) {
        const r = list[i]
        if (!r || String(r.aiDialogueChatRecordId || '').trim() !== rid || !r.waitAgentRes) {
          continue
        }
        this.$set(list, i, {
          ...r,
          waitAgentRes: false,
          _asaStreamDone: true,
          im750WaitStartedAt: undefined,
          im750ThinkingDismissed: true
        })
      }
    },
    /**
     * 兜底：长时间仍未收到结束标识（分片不齐等）则强制结束等待、清理缓冲（时长 IM750_WAIT_FORCE_MS）。
     */
    _tickIm750WaitForce () {
      const now = Date.now()
      const maxMs = IM750_WAIT_FORCE_MS
      const processList = (list) => {
        if (!Array.isArray(list)) return
        for (let i = list.length - 1; i >= 0; i--) {
          const r = list[i]
          if (!r || !r.waitAgentRes || r.im750WaitStartedAt == null) continue
          if (now - r.im750WaitStartedAt < maxMs) continue
          const rid = r.aiDialogueChatRecordId != null ? String(r.aiDialogueChatRecordId) : ''
          if (rid) removeIm750RecordBuffer(rid)
          const tip = String(r.im750ErrorTip || '').trim() ? r.im750ErrorTip : ''
          this.$set(list, i, {
            ...r,
            waitAgentRes: false,
            _asaStreamDone: true,
            im750WaitStartedAt: undefined,
            im750ErrorTip: tip
          })
        }
      }
      processList(this.aiHistoryMsgList)
      const cache = this.aiDialogueStreamCache
      if (cache && typeof cache === 'object') {
        for (const k of Object.keys(cache)) {
          const e = cache[k]
          if (e && Array.isArray(e.rows)) processList(e.rows)
        }
      }
    },
    /** 与 bloom-H5 agentResStreamLive 一致：历史落库全文直出；IM 过程中流式 */
    agentResStreamLive (row) {
      if (!row || typeof row !== 'object') return false
      if (row._asaStreamDone) return false
      if (row.waitAgentRes === true) return true
      return !row.agentResFromMsgLog
    },
    /**
     * 与 bloom-H5 agentResPartShowsStreamTypingDots 一致：流式中仅在最后一个文案片段末尾展示「. / .. / ...」；
     * 若其后已有卡片 / 选题树片段，或本轮已结束，则不展示。
     */
    agentResPartShowsStreamTypingDots (row, part, pi) {
      if (!row || typeof row !== 'object' || !part || part.type !== 'text') return false
      /** 结束 IM 可能早于最后一段正文：wait 已关但 _asaStreamDone 仍随 streamDone，此处单独关省略号 */
      if (row._asaAnswerEnded === true) return false
      if (!this.agentResStreamLive(row)) return false
      const parts = row.agentResParts
      if (!Array.isArray(parts) || parts.length === 0) return false
      let lastTextPi = -1
      for (let i = parts.length - 1; i >= 0; i--) {
        if (parts[i] && parts[i].type === 'text') {
          lastTextPi = i
          break
        }
      }
      if (lastTextPi < 0 || pi !== lastTextPi) return false
      for (let j = pi + 1; j < parts.length; j++) {
        const t = parts[j] && parts[j].type
        if (t === 'cards' || t === 'topicFence') return false
      }
      return true
    },
    /**
     * MSGLOG 首屏写入后：与切走会话时保存的快照按 recordId 合并，恢复 waitAgentRes / 流式 agentRes。
     */
    _mergeSnapshotDialogueIfAny (dialogueIdStr) {
      if (!dialogueIdStr) return
      const entry = this.aiDialogueStreamCache[dialogueIdStr]
      if (!entry || !Array.isArray(entry.rows) || !entry.rows.length) return
      for (let i = 0; i < this.aiHistoryMsgList.length; i++) {
        const serv = this.aiHistoryMsgList[i]
        if (!serv || serv.aiDialogueChatRecordId == null) continue
        const rid = String(serv.aiDialogueChatRecordId)
        const mem = entry.rows.find(
          (m) => m && m.aiDialogueChatRecordId != null && String(m.aiDialogueChatRecordId) === rid
        )
        if (!mem) continue
        if (
          mem.waitAgentRes === true ||
          this.agentResStreamLive(mem) ||
          String(mem.agentRes || '').length > String(serv.agentRes || '').length
        ) {
          const merged = {
            ...serv,
            ...mem,
            userReq:
              mem.userReq != null && String(mem.userReq) !== '' ? mem.userReq : serv.userReq,
            agentResFromMsgLog: false
          }
          if (merged.waitAgentRes && merged.im750WaitStartedAt == null) {
            merged.im750WaitStartedAt = Date.now()
          }
          this.$set(this.aiHistoryMsgList, i, merged)
        }
      }
      this.$delete(this.aiDialogueStreamCache, dialogueIdStr)
    },
    /**
     * 是否展示「思考中」浮层：与 aiHistoryMsgRowsForView 内 answerThinkingVisible 同源逻辑。
     * _aiIm750FirstPacketSeen：handleAiImRecord 在合并 agentRes 之前即写入，保证与流式同一 tick 内先关 loading。
     */
    aiAnswerThinkingOverlayVisible (row) {
      if (!row || typeof row !== 'object') return false
      if (!row.waitAgentRes) return false
      const rid = row.aiDialogueChatRecordId != null ? String(row.aiDialogueChatRecordId) : ''
      const seen = this._aiIm750FirstPacketSeen
      if (rid && seen && seen[rid] === true) return false
      if (row.im750ThinkingDismissed === true) return false
      if (String(row.im750ErrorTip || '').trim()) return false
      const raw = row.agentRes != null ? String(row.agentRes) : ''
      if (raw.length > 0) return false
      const layout = this.buildAgentResContestLayout(row.agentRes)
      if (layout.parts && layout.parts.length > 0) return false
      return true
    },
    /**
     * 任一条 750 进入本会话处理前即标记（recordId + 当前 pending 行 id），使思考浮层在写入 agentRes 之前消失。
     * @param {Array|undefined} listOverride 目标行列表（后台续写缓存时用）
     */
    _markAi750StreamBeganForIncoming750 (msg, msgUserReq, listOverride) {
      if (listOverride == null) {
        this.ensureAiIm750RuntimeState()
      } else {
        if (!this._aiIm750FirstPacketSeen || typeof this._aiIm750FirstPacketSeen !== 'object') {
          this._aiIm750FirstPacketSeen = {}
        }
        if (!Array.isArray(listOverride)) return
      }
      const rk =
        msg && msg.aiDialogueChatRecordId != null && msg.aiDialogueChatRecordId !== ''
          ? String(msg.aiDialogueChatRecordId)
          : ''
      if (rk) {
        this.$set(this._aiIm750FirstPacketSeen, rk, true)
      }
      const u = String(msgUserReq || '')
      const list = listOverride != null ? listOverride : this.aiHistoryMsgList
      let markedPending = false
      for (let i = list.length - 1; i >= 0; i--) {
        const r = list[i]
        if (!r || !r.__pending) continue
        if (u && String(r.userReq || '') !== u) continue
        const cid = String(r.aiDialogueChatRecordId || '')
        if (cid) {
          this.$set(this._aiIm750FirstPacketSeen, cid, true)
          markedPending = true
        }
        break
      }
      /** 首包常带服务端 recordId，列表行仍为 tmp-id；须同步标记 tmp，否则 answerThinkingVisible 仍读 tmp 查不到 seen */
      if (!markedPending) {
        for (let j = list.length - 1; j >= 0; j--) {
          const r2 = list[j]
          if (!r2 || !r2.__pending || String(r2.agentRes || '').trim()) continue
          const cid2 = String(r2.aiDialogueChatRecordId || '')
          if (cid2) {
            this.$set(this._aiIm750FirstPacketSeen, cid2, true)
          }
          break
        }
      }
    },
    _clearAiThinkingDotsTimer () {
      if (this._aiThinkingDotsTimer != null) {
        clearInterval(this._aiThinkingDotsTimer)
        this._aiThinkingDotsTimer = null
      }
    },
    /** 流式 tick 时合并滚动，与 bloom-H5 scrollAiChatToBottomStream 一致 */
    scrollAiChatToBottomStream () {
      if (this._aiStreamScrollRaf != null) return
      this._aiStreamScrollRaf = requestAnimationFrame(() => {
        this._aiStreamScrollRaf = null
        const el = this.$refs.aiChatScroll
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    /**
     * 合并 IM750 到 agentRes：带 sort 时缓冲去乱序，仅按 1,2,… 连续片段展示；无 sort 时与旧逻辑同（直接拼接）。
     */
    im750MergeAgentResState (msg, { prev, contentPiece, msgAgentRes, isErrorKind, answerComplete, recordId }) {
      const rid = recordId != null && recordId !== '' ? String(recordId) : ''
      const { sort, totalParts } = getIm750SortMeta(msg)
      const recBuf = rid ? getIm750RecordBuffer(rid) : null
      const res = mergeIm750AgentResState({
        prevAgentRes: prev,
        contentPiece,
        msgAgentRes,
        isErrorKind,
        answerComplete,
        sort,
        totalParts,
        recordBuffer: recBuf
      })
      if (isErrorKind && rid) {
        removeIm750RecordBuffer(rid)
      } else if (res.useBuffer && rid) {
        if (res.streamDone) {
          removeIm750RecordBuffer(rid)
        } else {
          setIm750RecordBuffer(rid, res.nextBuffer)
        }
      } else if (!res.useBuffer && rid && recBuf) {
        removeIm750RecordBuffer(rid)
      }
      return res
    },

    /**
     * 同一条 assistant 行在 _asaStreamDone 后若仍收到迟到 content（如结束包早于最后一段正文），
     * 合并逻辑会得到 nextWait=true；此处禁止再次打开 wait，避免界面永久停在「等待/停止」。
     * @param {object|null|undefined} row 合并前的当前行
     */
    im750EffectiveNextWait (row, mergeNextWait, isErrorKind) {
      if (row && row._asaStreamDone === true && !isErrorKind) return false
      const rowRid =
        row && row.aiDialogueChatRecordId != null
          ? String(row.aiDialogueChatRecordId).trim()
          : ''
      if (
        rowRid &&
        this._im750AnswerEndedRecordIds &&
        this._im750AnswerEndedRecordIds.has(rowRid)
      ) {
        return false
      }
      return mergeNextWait
    },

    /**
     * 服务端在 IM 上标记本轮结束时立即解除等待；迟到分片仍更新 merge.agentRes。
     */
    computeIm750UiWaitAfterMerge (
      row,
      merge,
      answerComplete,
      isErrorKind,
      recordIdForWait
    ) {
      const rid =
        recordIdForWait != null && recordIdForWait !== ''
          ? String(recordIdForWait).trim()
          : ''
      if (
        rid &&
        this._im750AnswerEndedRecordIds &&
        this._im750AnswerEndedRecordIds.has(rid)
      ) {
        return false
      }
      if (answerComplete) return false
      return this.im750EffectiveNextWait(row, merge.nextWait, isErrorKind)
    },

    /** 本轮已在 IM 上收到结束标识后，同 aiDialogueChatRecordId 的后续包不得再打开 waitAgentRes（与 H5 一致） */
    _markIm750RecordAnswerEnded (ridStr) {
      const r = ridStr != null ? String(ridStr).trim() : ''
      if (!r) return
      if (!this._im750AnswerEndedRecordIds) {
        this._im750AnswerEndedRecordIds = new Set()
      }
      this._im750AnswerEndedRecordIds.add(r)
    },

    /** kind=error：记入 Set，同 aiDialogueChatRecordId 的后续 IM 一律丢弃 */
    _markIm750ErrorRecord (ridStr) {
      const r = ridStr != null ? String(ridStr).trim() : ''
      if (!r) return
      if (!this._im750ErrorRecordIds) {
        this._im750ErrorRecordIds = new Set()
      }
      this._im750ErrorRecordIds.add(r)
      removeIm750RecordBuffer(r)
    },

    _im750RecordIsErrorBlocked (ridStr) {
      const r = ridStr != null ? String(ridStr).trim() : ''
      return Boolean(r && this._im750ErrorRecordIds && this._im750ErrorRecordIds.has(r))
    },

    /**
     * IM 监听：chatMsgType=750 为伴学助手；会话一致时按 aiDialogueChatRecordId 定位记录，将 content 拼入 agentRes。
     * IM kind=error：气泡展示 errMessage，同 recordId 的 userReq/agentRes 及后续 IM 均不展示。
     */
    handleAiImRecord (msg) {
      if (!msg) return
      const chatMsgType = Number(msg.chatMsgType)
      if (chatMsgType !== 750) return
      console.log('[IM750][bloom-pc]', msg)
      if (!this.aiAssistantVisible) {
        this.aiAssistantUnreadCount = Math.min(this.aiAssistantUnreadCount + 1, 999)
        return
      }
      const dStr = msg.aiDialogueId != null && msg.aiDialogueId !== '' ? String(msg.aiDialogueId) : ''
      if (!dStr) {
        this.aiAssistantUnreadCount = Math.min(this.aiAssistantUnreadCount + 1, 999)
        return
      }
      const curStr =
        this.aiCurrentDialogueId != null && this.aiCurrentDialogueId !== ''
          ? String(this.aiCurrentDialogueId)
          : ''
      const isForeground = Boolean(curStr && dStr === curStr)
      let rowList
      if (isForeground) {
        rowList = this.aiHistoryMsgList
      } else {
        let cacheEntry = this.aiDialogueStreamCache[dStr]
        if (!cacheEntry || !Array.isArray(cacheEntry.rows)) {
          this.$set(this.aiDialogueStreamCache, dStr, { rows: [] })
          cacheEntry = this.aiDialogueStreamCache[dStr]
        }
        rowList = cacheEntry.rows
      }
      const isMain = isForeground
      if (isMain) {
        this.ensureAiIm750RuntimeState()
      } else {
        if (!this._aiIm750FirstPacketSeen || typeof this._aiIm750FirstPacketSeen !== 'object') {
          this._aiIm750FirstPacketSeen = {}
        }
      }
      const recordId = msg.aiDialogueChatRecordId
      const msgUserReq = msg.userReq != null ? String(msg.userReq) : ''
      const ridStr =
        recordId != null && String(recordId).trim() !== ''
          ? String(recordId).trim()
          : ''
      if (this._im750AbortedRecordIds && ridStr && this._im750AbortedRecordIds.has(ridStr)) {
        return
      }
      if (this._im750RecordIsErrorBlocked(ridStr)) {
        return
      }
      /** 用户曾点停止且当时尚无服务端 recordId：同会话下行必须丢弃，直至包内出现 recordId 并记入 Set */
      const pend = this._im750AbortPending
      if (pend && String(pend.dialogueId) === dStr) {
        if (ridStr) {
          if (!this._im750AbortedRecordIds) this._im750AbortedRecordIds = new Set()
          this._im750AbortedRecordIds.add(ridStr)
          removeIm750RecordBuffer(ridStr)
          this._im750AbortPending = null
        }
        return
      }

      this._markAi750StreamBeganForIncoming750(
        msg,
        msgUserReq,
        isMain ? null : rowList
      )

      const answerComplete = this.isIm750AnswerComplete(msg)
      if (answerComplete && ridStr) {
        this._markIm750RecordAnswerEnded(ridStr)
      }
      const msgAgentRes = msg.agentRes != null ? String(msg.agentRes) : ''
      let md = msg.messageData
      if (md != null && typeof md === 'string') {
        const t = md.trim()
        if (t.startsWith('{') || t.startsWith('[')) {
          try {
            md = JSON.parse(md)
          } catch (e) {
            md = null
          }
        } else {
          md = null
        }
      }
      const isFenceKind = md && String(md.kind || '').toLowerCase() === 'fence'
      const mdContent = isFenceKind && md.content != null ? String(md.content).trim() : ''
      let contentPiece =
        mdContent !== '' ? String(md.content) : (msg.content != null ? String(msg.content) : '')
      const msgKindLower = String(msg.kind || '').toLowerCase()
      const mdIsObject = md && typeof md === 'object' && !Array.isArray(md)
      const mdKindLower = mdIsObject ? String(md.kind || '').toLowerCase() : ''
      // console.log(contentPiece, 'contentPiece')
      // console.log(md.content, 'md.content')
      // console.log(msg.content, 'msg.content')
      /**
       * IM 错误（含敏感）：messageData.kind=error，或根级 kind=error 且 messageData 非流式片段（无 kind / kind=error），
       * 避免与 kind=fence|complete 等业务包并存根级字段时误判。
       */
      const isErrorKind =
        mdKindLower === 'error' ||
        (msgKindLower === 'error' &&
          (!mdIsObject || !mdKindLower || mdKindLower === 'error'))
      if (isErrorKind) {
        contentPiece = ''
      }
      const errorTipMessage = (() => {
        if (!isErrorKind) return ''
        let t = ''
        if (mdIsObject && md.errMessage != null) {
          t = String(md.errMessage).trim()
        }
        if (!t && msg.errMessage != null) {
          t = String(msg.errMessage).trim()
        }
        return t !== '' ? t : this.$t('aiStudyBuddy.im750SensitiveTipFallback')
      })()
      if (isErrorKind && ridStr) {
        this._markIm750ErrorRecord(ridStr)
      }

      if (recordId != null && recordId !== '') {
        const idx = this.resolveAiHistoryRowIndexForIm750Incoming(rowList, recordId)
        if (idx > -1) {
          const row = rowList[idx]
          if (row && row._asaUserAborted) return
          const prev = row.agentRes != null ? String(row.agentRes) : ''
          const merge = this.im750MergeAgentResState(msg, {
            prev,
            contentPiece,
            msgAgentRes,
            isErrorKind,
            answerComplete,
            recordId
          })
          const next = isErrorKind ? '' : merge.agentRes
          /**
           * 敏感/错误首包写入 im750ErrorTip 后，后续 complete 等非 error 包仍会到达；
           * 仅在「正常结束且已有回答正文」时清空提示，避免一闪即无。
           */
          const nextIm750ErrorTip = isErrorKind
            ? errorTipMessage
            : merge.streamDone && String(next || '').trim()
              ? ''
              : (row.im750ErrorTip || '')
          const nextUserReq = isErrorKind
            ? ''
            : (String(msgUserReq || '').trim() || row.userReq)
          const nextWaitEff = this.computeIm750UiWaitAfterMerge(
            row,
            merge,
            answerComplete,
            isErrorKind,
            recordId
          )
          this.$set(rowList, idx, {
            ...row,
            aiDialogueChatRecordId: recordId,
            userReq: nextUserReq,
            agentRes: next,
            __pending: false,
            waitAgentRes: nextWaitEff,
            im750WaitStartedAt: nextWaitEff
              ? (row.im750WaitStartedAt != null ? row.im750WaitStartedAt : Date.now())
              : undefined,
            im750ThinkingDismissed: true,
            agentResFromMsgLog: false,
            im750ErrorTip: nextIm750ErrorTip,
            ...(merge.streamDone ? { _asaStreamDone: true } : {}),
            ...(answerComplete ? { _asaAnswerEnded: true } : {})
          })
          if (merge.streamDone || answerComplete) {
            this.clearWaitAgentResAfter750Complete(
              recordId,
              msgUserReq,
              isMain ? null : rowList
            )
          }
          if (answerComplete && ridStr) {
            this._im750SweepClearWaitForAnswerComplete(rowList, ridStr)
          }
          if (isMain) {
            this.scrollAiChatToBottomStream()
          }
          return
        }
      }

      // 无服务端 recordId 或未命中列表时：兼容首包或本地 pending
      const fallbackId = recordId || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
      let pendingIdx = rowList.findIndex(
        (row) => row && row.__pending && row.userReq === msgUserReq && !row.agentRes
      )
      if (pendingIdx < 0 && isErrorKind && !String(msgUserReq || '').trim()) {
        for (let pi = rowList.length - 1; pi >= 0; pi--) {
          const pr = rowList[pi]
          if (pr && pr.__pending && !pr.agentRes) {
            pendingIdx = pi
            break
          }
        }
      }
      let mergeTail = null
      if (pendingIdx > -1) {
        const pendingRow = rowList[pendingIdx]
        if (pendingRow && pendingRow._asaUserAborted) return
        const prev = pendingRow.agentRes != null ? String(pendingRow.agentRes) : ''
        const recIdForPending = recordId != null && recordId !== '' ? recordId : fallbackId
        const merge = this.im750MergeAgentResState(msg, {
          prev,
          contentPiece,
          msgAgentRes,
          isErrorKind,
          answerComplete,
          recordId: recIdForPending
        })
        mergeTail = merge
        const base = isErrorKind ? '' : merge.agentRes
        const tip = isErrorKind
          ? errorTipMessage
          : (String(pendingRow.im750ErrorTip || '').trim() ? pendingRow.im750ErrorTip : '')
        const nextPendingUserReq = isErrorKind
          ? ''
          : (String(msgUserReq || '').trim() || String(pendingRow.userReq || ''))
        const nextWaitPending = this.computeIm750UiWaitAfterMerge(
          pendingRow,
          merge,
          answerComplete,
          isErrorKind,
          recIdForPending
        )
        this.$set(rowList, pendingIdx, {
          aiDialogueChatRecordId: recIdForPending,
          userReq: nextPendingUserReq,
          agentRes: base,
          __pending: false,
          waitAgentRes: nextWaitPending,
          im750WaitStartedAt: nextWaitPending
            ? (pendingRow.im750WaitStartedAt != null ? pendingRow.im750WaitStartedAt : Date.now())
            : undefined,
          im750ThinkingDismissed: true,
          agentResFromMsgLog: false,
          im750ErrorTip: tip,
          ...(merge.streamDone ? { _asaStreamDone: true } : {}),
          ...(answerComplete ? { _asaAnswerEnded: true } : {})
        })
      } else {
        const mergePushRid =
          recordId != null && recordId !== '' ? recordId : fallbackId
        const mergePush = this.im750MergeAgentResState(msg, {
          prev: '',
          contentPiece,
          msgAgentRes,
          isErrorKind,
          answerComplete,
          recordId: mergePushRid
        })
        mergeTail = mergePush
        const nextWaitPush = this.computeIm750UiWaitAfterMerge(
          null,
          mergePush,
          answerComplete,
          isErrorKind,
          mergePushRid
        )
        rowList.push({
          aiDialogueChatRecordId: recordId != null && recordId !== '' ? recordId : fallbackId,
          userReq: isErrorKind ? '' : msgUserReq,
          agentRes: isErrorKind ? '' : mergePush.agentRes,
          waitAgentRes: nextWaitPush,
          im750WaitStartedAt: nextWaitPush ? Date.now() : undefined,
          im750ThinkingDismissed: true,
          agentResFromMsgLog: false,
          im750ErrorTip: isErrorKind ? errorTipMessage : '',
          ...(mergePush.streamDone ? { _asaStreamDone: true } : {}),
          ...(answerComplete ? { _asaAnswerEnded: true } : {})
        })
      }
      if (mergeTail && (mergeTail.streamDone || answerComplete)) {
        this.clearWaitAgentResAfter750Complete(recordId, msgUserReq, isMain ? null : rowList)
      }
      if (answerComplete && ridStr) {
        this._im750SweepClearWaitForAnswerComplete(rowList, ridStr)
      }
      if (isMain) {
        this.scrollAiChatToBottomStream()
      }
    },
    /** 阻止滚轮穿透到底层页面；聊天区/多行输入在可滚动时仍正常滚动 */
    _onAiAssistantWheel (e) {
      const scrollEl = this.$refs.aiChatScroll
      if (scrollEl && scrollEl.contains(e.target)) {
        const { scrollTop, scrollHeight, clientHeight } = scrollEl
        const dy = e.deltaY
        const eps = 2
        const canScrollUp = scrollTop > eps
        const canScrollDown = scrollTop + clientHeight < scrollHeight - eps
        if (dy < 0 && canScrollUp) return
        if (dy > 0 && canScrollDown) return
        e.preventDefault()
        return
      }
      const sidebarEl = this.$refs.aiAssistantSidebar
      if (sidebarEl && sidebarEl.contains(e.target)) {
        /** 侧栏根节点 overflow:hidden，真正纵向滚动的是「历史对话」子列表 */
        const historyListEl =
          e.target.closest && e.target.closest('.ai-sidebar-history-list')
        const wheelScrollEl =
          historyListEl && sidebarEl.contains(historyListEl) ? historyListEl : sidebarEl
        const { scrollTop, scrollHeight, clientHeight } = wheelScrollEl
        const dy = e.deltaY
        const eps = 2
        const canScrollUp = scrollTop > eps
        const canScrollDown = scrollTop + clientHeight < scrollHeight - eps
        if (dy < 0 && canScrollUp) return
        if (dy > 0 && canScrollDown) return
        e.preventDefault()
        return
      }
      const ta = e.target.closest && e.target.closest('textarea.ai-input-field')
      if (ta) {
        const { scrollTop, scrollHeight, clientHeight } = ta
        const dy = e.deltaY
        const eps = 1
        const canScrollUp = scrollTop > eps
        const canScrollDown = scrollTop + clientHeight < scrollHeight - eps
        if (dy < 0 && canScrollUp) return
        if (dy > 0 && canScrollDown) return
        e.preventDefault()
        return
      }
      e.preventDefault()
    },
    /** 全屏时锁 body；缩小模式不锁，便于在弹窗外滚动页面 */
    _syncAiAssistantBodyScrollLock () {
      const docEl = document.documentElement
      const lock = this.aiAssistantVisible && !this.aiAssistantCompact
      if (lock) {
        docEl.style.overflow = 'hidden'
        docEl.style.overscrollBehavior = 'none'
        document.body.style.overflow = 'hidden'
        document.body.style.overscrollBehavior = 'none'
      } else {
        docEl.style.overflow = ''
        docEl.style.overscrollBehavior = ''
        document.body.style.overflow = ''
        document.body.style.overscrollBehavior = ''
      }
    },
    _setAiAssistantScrollLock (open) {
      if (open) {
        this._syncAiAssistantBodyScrollLock()
        this.$nextTick(() => {
          const el = this.$refs.aiAssistantPanel
          if (el) {
            el.addEventListener('wheel', this._onAiAssistantWheel, { passive: false })
          }
        })
      } else {
        document.documentElement.style.overflow = ''
        document.documentElement.style.overscrollBehavior = ''
        document.body.style.overflow = ''
        document.body.style.overscrollBehavior = ''
        const el = this.$refs.aiAssistantPanel
        if (el) {
          el.removeEventListener('wheel', this._onAiAssistantWheel, { passive: false })
        }
      }
    },
    // 去活动广场
    activityBtn () {
      this.$utils.CzcTrackEvent(this.$route.name, '头部小铃铛点击', '')
      this.$router.push({
        path: '/EventPlaza/InfoList'
      })
    },
    // 切换中英文
    changeLang () {
      this.lang = this.$i18n.locale === 'en' ? 'zh' : 'en'
      this.$i18n.locale = this.lang
      this.$nextTick(() => {
        this.$utils.cache('bloom:lang', this.$i18n.locale)
      })
    },
    // 去教练端 USER_JUMP_COACH  ticket
    goCoach () {
      this.$api.post('USER_JUMP_COACH', {}, res => {
        let ticket = res.data || ''
        let str = window.location.origin
        if (str.indexOf('top') > -1) {
          this.coachHref = 'http://coach.webloom.top/#/home?ticket=' + ticket
          // this.coachHref = 'http://localhost:8066/#/Index?ticket=' + ticket
        } else {
          this.coachHref = 'https://coach.webloom.cn/#/home?ticket=' + ticket
          // this.coachHref = 'http://coach.webloom.top/#/home?ticket=' + ticket
          // this.coachHref = 'http://localhost:8066/#/Index?ticket=' + ticket
        }
        this.$nextTick(() => {
          this.$refs.coachBtna.click()
        })
      })
    },
    checkStatu () {
      this.getLoginState()
    },
    navBtn (index, title) {
      // this.itemIndex = index
      if (title === '精彩图集') {
        this.$router.push('/wonderfulList/index')
      } else if (title === '发现') {
        this.itemIndex = index
        this.$router.push({
          name: 'DiscoverHome'
        })
      } else if (title === '首页') {
        this.$router.push('/')
      }
    },
    // 下拉列表点击事件
    dropdownList (command) {
      this.$router.push({
        path: `/GameData/${command.nameEn}`,
        query: {
          contestId: command.contestId,
          seasonId: command.seasonId
        }
      })
    },
    // 弹出登录框
    handleLogin () {
      this.$_Login()
    },
    //
    headerPopoverShow () {
      if (!this.canGetNum) {
        return
      }
      this.canGetNum = false
      let data = {}
      this.$api.purePost('TICKET_STUDENT_UNM', data, (res) => {
        this.TicketNum = res.data || 0
        setTimeout(() => {
          this.canGetNum = true
        })
      })
    },
    handleCommand (command) {
      this.$utils.CzcTrackEvent(this.$route.name, '头像下拉框', command)
      if (command === 'logout') {
        this.logout()
      } else if (command === 'EventPlaza_MineList') {
        this.activeIndex = 0
        this.$router.push({
          name: 'EventPlaza_MineList',
          query: {
            t: new Date().getTime()
          }
        })
      } else if (command === 'MySociety') {
        this.activeIndex = 0
        this.$router.push({
          name: 'MySociety',
          query: {
            t: new Date().getTime()
          }
        })
      } else if (command === 'CourseDetails') {
        this.activeIndex = 0
        this.$router.push(`/CourseDetails`)
      } else if (command === 'battleCenter') {
        this.activeIndex = 0
        this.$router.push(`/BattleCenter`)
      } else if (command === 'setting') {
        this.activeIndex = 0
        this.$router.push(`/PersonalCenter/UserCenter`)
      } else if (command === 'MessageUs') {
        console.log('https://img.webloom.cn/Img/gondan1.png')
        // this.$router.push(`/PersonalCenter/workOrder`)
        this.$router.push(`/workOrder`)
      } else {
        if (command === 'UserCenter') this.$utils.CzcTrackEvent('个人中心', '进入个人资料')
        if (command === 'MyActivities') this.$utils.CzcTrackEvent('首页', '点击我的活动入口')
        this.activeIndex = 0
        this.$router.push(`/PersonalCenter/${command}`)
      }
    },
    // 登录方法
    ...mapMutations([
      'set_isLogin',
      'set_activityMessage'
    ]),
    // 退出登录
    logout () {
      this.$api.post('USER_LOGOUT', '', async (res) => {
        try {
          await this.handleCustomerImLogoutOnError()
        } catch (e) {
          console.warn('退出登录时销毁客服 IM', e)
        }
        window.localStorage.removeItem('userData')
        this.$store.commit('set_isLogin', false)
        this.$emit('logout')
        window.location.href = `/bloom_web/#/`
      })
    },
    /**
     * 与 all-btn.handleLogoutOnError 中文案一致：登出并销毁全局客服/伴学共用的 IM 实例
     */
    async handleCustomerImLogoutOnError () {
      await destroyCustomerImOnError()
    },
    /**
     * 打开伴学助手时预连接客服 IM（与智能客服共用单例，不传 onMessage 以免覆盖客服 handleIMMessage）
     */
    async ensureCustomerImForAiAssistant () {
      try {
        await ensureCustomerImReady({
          limitPost: this.$api.limitPost.bind(this.$api),
          post: this.$api.post.bind(this.$api),
          cookie: this.$cookie,
          utils: this.$utils,
          onLoginState: (res, err) => {
            const code = res && res.code !== undefined ? res.code : (err && err.code)
            if (code === 10016) {
              this.$store.commit('set_isLogin', false)
            }
          }
        })
      } catch (e) {
        console.warn('伴学助手 IM 预连接失败', e)
      }
    },
    getLoginState (isInit = false) {
      this.$api.limitPost('LOGIN_STATE', {}, (res) => {
        if (res.code === 10016) this.$store.commit('set_isLogin', false)
      }, (err) => {
        if (err.code === 10016) this.$store.commit('set_isLogin', false)
      })
      setTimeout(() => {
        if (isInit) this.init()
      }, 0)
    },
    // 是否显示隐藏
    bolFn () {
      this.itemIndex = this.$route.meta.itemIndex || 0
      if (this.$route.meta.IndexHeader || this.$route.name === 'userAgreement' || this.$route.name === 'recoverPassword' || (this.$route.path.indexOf('/EventPlaza') > -1) || (this.$route.name === 'Joint') || (this.$route.query.battleId && this.$route.name === 'waitingExamination') || this.$route.name === 'proctorIpad') {
        this.bol = true
        if (this.list[0].width !== 0) return
        this.$nextTick(() => {
          this.list.forEach((item, index) => {
            item.width = this.$refs['a' + index][0].offsetWidth
          })
        })
      } else {
        this.bol = false
      }
    },
    // 获取赛事列表
    getList () {
      this.$getCommon('NEW_CONTEST_LIST', {}).then(({ data }) => {
        this.projectList = data.list || []
        // 存下活动列表给工单用
        sessionStorage.setItem('actList', JSON.stringify(this.projectList))
        // console.log(this.projectList, 'CONTEST_LIST')
      })
      // this.$api.purePost('CONTEST_LIST', {}, (res) => {
      //   this.projectList = res.data.list || []
      // })
    },
    // 跳转登录
    jumpLogin () {
      // console.log(123)
      this.$api.post('USER_LOGIN_TICKET', {ticket: this.$route.query.ticket}, res => {
        this.$store.commit('set_isLogin', true)
        this.$utils.cache('userData', JSON.stringify(res.data))
        this.$router.replace({
          path: this.$route.path
        })
        this.$nextTick(() => {
          window.location.reload()
        })
      })
    },
    // 活动消息按钮显示
    isEventPlazaBtn () {
      if (this.$route.path.indexOf('EventPlaza') > -1 && !this.EventPlazaBtn) {
        this.EventPlazaBtn = true
      } else {
        this.EventPlazaBtn = false
      }
    },
    // 获取活动消息数量
    getEventPlazaBtn () {
      this.$api.post('MESSAGE_UNREADNUM_ALL', {}, res => {
        let num = res.data || 0
        this.$store.commit('set_unRead', num)
      })
    },
    setLang () {
      this.$i18n.locale = this.$utils.cache('bloom:lang') === 'en' ? 'en' : 'zh'
    },
    // 初始化
    init () {
      console.log('init')
      this.getList()
      this.getEventPlazaBtn()
      this.bolFn()
      this.setLang()
      let userData = JSON.parse(this.$utils.cache('userData'))
      if (userData) {
        this.hearderImg = userData.portraitPath || ''
        this.userId = userData.userId || ''
        this.userType = userData.userType || 0
        this.set_isLogin(true)
      }
    },
    // 监听滚动条
    handleScroll (e) {
      let scrollTop = document.documentElement.scrollTop
      if (this.$route.meta.needScroll) {
        if (scrollTop > 10) {
          this.isScroll = true
        } else {
          this.isScroll = false
        }
      } else {
        this.isScroll = true
      }
    }
  },
  mounted () {
    // this.init()
    // this.getLoginState()
    // this.isScroll = this.$route.name === 'Index'
    // if (this.$route.name === 'Index') {
    //
    // }
    this.isMounted = true
    if (this.$route.path.indexOf('planet') > -1) {
      this.itemIndex = 3
    }
    // this.$nextTick(() => {
    //   // this.handleScroll()
    //   console.log(this.$route, 'this.$route.name77')
    //   if (this.$route.fullPath !== '/') {
    //     // window.addEventListener('scroll', this.handleScroll, true)
    //     this.isScroll = true
    //     this.$forceUpdate()
    //   } else {
    //
    //   }
    //   this.handleScroll()
    // })
    // console.log(this.$route, 'this.this.$routethis.$routethis.$route')
    // console.log(document.getElementById('HeaderBox'), 'HeaderBox')
    setTimeout(() => {
      const hb = document.getElementById('HeaderBox')
      if (hb) hb.classList.add('H60')
    }, 200)
    if (this._im750WaitForceTick == null) {
      this._im750WaitForceTick = setInterval(() => {
        this._tickIm750WaitForce()
      }, 3000)
    }
    // document.getElementById('HeaderBox').classList.add('H60')
    // setTimeout(() => {
    //   document.getElementById('HeaderBox').classList.add('ov')
    // }, 2000)
  },
  created () {
    this.init()
    this.initAiAssistantEntryPlaceholder()
    this.shuffleAiQuickChipsPick()
    window.addEventListener('scroll', this.handleScroll, true)
    if (this.$bus) {
      this.$bus.$on('open-ai-assistant-from-bloom-header', this.openAiAssistantFromBloomHeader)
      this.$bus.$on('open-ai-assistant-with-tab', this._onOpenAiAssistantWithTab)
    }
    this._aiSendOrStopLead = debounceLead(() => {
      if (this.aiSendLoading) return
      if (this.aiAssistantWaitingImReply) {
        this.stopAiAssistantGeneration()
        return
      }
      this.onAiSend()
    }, 350)
    this._aiSendLead = debounceLead(() => {
      this.onAiSend()
    }, 350)
  },
  beforeDestroy () {
    if (this.$bus) {
      this.$bus.$off('open-ai-assistant-from-bloom-header', this.openAiAssistantFromBloomHeader)
      this.$bus.$off('open-ai-assistant-with-tab', this._onOpenAiAssistantWithTab)
    }
    document.documentElement.style.overflow = ''
    document.documentElement.style.overscrollBehavior = ''
    document.body.style.overflow = ''
    document.body.style.overscrollBehavior = ''
    const el = this.$refs.aiAssistantPanel
    if (el) {
      el.removeEventListener('wheel', this._onAiAssistantWheel, { passive: false })
    }
    if (this._im750WaitForceTick != null) {
      clearInterval(this._im750WaitForceTick)
      this._im750WaitForceTick = null
    }
    if (this._aiStreamScrollRaf != null) {
      cancelAnimationFrame(this._aiStreamScrollRaf)
      this._aiStreamScrollRaf = null
    }
    this._clearAiThinkingDotsTimer()
    if (this._aiSendOrStopLead && typeof this._aiSendOrStopLead.cancel === 'function') {
      this._aiSendOrStopLead.cancel()
    }
    if (this._aiSendLead && typeof this._aiSendLead.cancel === 'function') {
      this._aiSendLead.cancel()
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log(to)
    next()
  },
  watch: {
    aiAssistantVisible: {
      handler (v) {
        this._setAiAssistantScrollLock(v)
        if (v) {
          /** 打开面板时不在此处请求 DIALOGUE_LIST；用户展开「历史对话」子列表时再拉取 */
          this.ensureCustomerImForAiAssistant()
          this.$nextTick(() => this.adjustAiTextareaHeight())
        }
      },
      immediate: true
    },
    aiAssistantCompact () {
      if (this.aiAssistantVisible) {
        this._syncAiAssistantBodyScrollLock()
      }
    },
    aiAssistantAnswerAreaLoading (v) {
      if (v) {
        this.aiThinkingDotsPhase = 0
        this._clearAiThinkingDotsTimer()
        this._aiThinkingDotsTimer = setInterval(() => {
          this.aiThinkingDotsPhase = (this.aiThinkingDotsPhase + 1) % 3
        }, 450)
      } else {
        this._clearAiThinkingDotsTimer()
      }
    },
    'lang' () {
      this.initAiAssistantEntryPlaceholder()
      this.$nextTick(() => {
        this.adjustAiTextareaHeight()
        this.list.forEach((item, index) => {
          const ref = this.$refs['a' + index]
          if (ref && ref[0]) {
            item.width = ref[0].offsetWidth
          }
        })
      })
    },
    '$route' () {
      /** 大窗口模式下头部仍可点链接触发跳转；跳转后收为小窗口，避免遮挡新页面 */
      if (this.aiAssistantVisible && !this.aiAssistantCompact) {
        this.aiAssistantCompact = true
        this.aiCompactSidebarOpen = false
      }
      console.log(this.$route.meta, 'this.$route.meta,this.$route.meta--------------')
      this.bolFn()
      let name = this.$route.name
      let list = [...this.list]
      this.itemIndex = -3
      for (let i = 0; i < list.length; i++) {
        if (list[i].title.name === name) {
          this.itemIndex = i
        }
      }
      if (name.indexOf('EventPlaza') > -1) {
        this.itemIndex = 2
      }
      if (this.$route.query.contestId || this.$route.params.contestId) {
        let contestId = this.$route.query.contestId || this.$route.params.contestId
        this.$utils.cache('contestId', contestId)
      }
      if (this.$route.meta.needScroll) {
        this.isScroll = true
        this.$forceUpdate()
      }

      // 有就是教练端来的
      if (this.$route.query.ticket) {
        this.jumpLogin()
      }
      if (this.$route.path.indexOf('EventPlaza') > -1) {
        this.EventPlazaBtn = true
      }
      this.routeName = this.$route.name
      this.$forceUpdate()
      this.handleScroll()
      console.log(this.isScroll, '-------------')
    },
    'isLogin' () {
      this.init()
      if (
        this.isLogin &&
        this.aiAssistantVisible &&
        this.aiHistorySidebarExpanded &&
        !this.aiChatHistory.some((h) => h.fromServer)
      ) {
        this.loadAiDialogueList()
      }
    },
    customerImParsedMessage: {
      handler (msg) {
        this.handleAiImRecord(msg)
      },
      deep: true
    },
    'itemIndex' () {
      console.log(this.itemIndex, 'itemIndex')
    }
  },
  components: {
    seasonDrop,
    PlazaDrop,
    AiAssistantTopicFence,
    AiStreamingText
  }
}
</script>
<style lang="scss">
  /* 伴学侧栏「历史对话」列表：Tooltip 需高于面板（.ai-assistant-panel 为 3000，Element 默认约 2000+）否则气泡被主区域盖住 */
  .ai-sidebar-history-tooltip {
    z-index: 3100 !important;
  }
  /* 高于 .ai-assistant-panel（3000），伴学打开时头像 hover 下拉不被挡住 */
  .headerPopover {
    z-index: 3100 !important;
    padding: 20px;
    width: 166px;
    .popoverCent{
      width: 166px;
      .contentItem{
        cursor: pointer;
        height: 47px;
        //background: #DBE6FF;
        border-radius: 10px;
        align-items: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .itemIn {
          display: flex;
          justify-content: center;
          align-items: center;
          .itemInIcon{
            width: 20px;
            height: 20px;
            display: block;
          }
          .itemInIcon1 {
            display: none;
            width: 20px;
            height: 20px;
          }
          .itemInTxt{
            margin-left: 17px;
            width: 72px;
            height: 23px;
            font-size: 16px;
            font-family: MicrosoftYaHeiUI;
            color: #212121;
            line-height: 23px;
            position: relative;
            .TicketNum {
              min-width: 16px;
              height: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              box-sizing: border-box;
              background: #FF2F49;
              position: absolute;
              top: -8px;
              right: -4px;;
              border-radius: 16px;
              padding: 0 4px!important;
            }
          }
          .itemInTxtEn {
            margin-left: 17px;
            min-width: 112px;
            height: 23px;
            font-size: 16px;
            font-family: MicrosoftYaHeiUI;
            color: #212121;
            line-height: 23px;
            position: relative;
            .TicketNum {
              min-width: 8px;
              height: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 17px;
              text-align: center;
              font-style: normal;
              background: #FF2F49;
              position: absolute;
              top: -8px;
              right: 24px;
              border-radius: 16px;
              padding: 0 4px!important;
            }
          }
          .exit {
            color: #6D6E70;
          }
        }
      }
      .contentItem:hover{
        background: #DBE6FF;
        .itemInIcon {
          display: none;
        }
        .itemInIcon1 {
          display: block;
          width: 20px;
          height: 20px;
        }
        .itemInTxt{
          color: #296BFF;
        }
        .itemInTxtEn {
          color: #296BFF;
        }
        .exit {
          color: #6D6E70;
        }
      }
      .exitBox:hover {
        color: #212121;
      }
    }
  }
</style>
<style lang="scss" scoped>
$width : 100vw/1920;
.MT60 {
  margin-top: -60*$width;
}
.HeaderBox{
  //width: 100%;
  width: 100vw;
  height: 60*$width;
  //margin-top: -60*$width;
  //height: 0;
  box-shadow: 0 13*$width 32*$width -10*$width rgba(0,0,0,0.08);
  position: sticky;
  top: -1px;
  //top: 36px;
  //top: -60*$width;
  left: 0;
  //overflow: hidden;
  //background-color: #fff;
  z-index: 100;
  /* 保证头部导航与语言切换叠在 AI 弹窗之上 */
  > .ward {
    position: relative;
    z-index: 2;
  }
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(5px);
  //transition: height 2s;
  //transition: top 2s;
  //transition: overflow 2s;
  .change-lang {
    width: 70*$width;
    height: 26*$width;
    border-radius: 14*$width;
    border: 1px solid #BEBEBE;
    position: absolute;
    z-index: 2;
    right: 20*$width;
    top: 12*$width;
    text-align: center;
    font-size: 13*$width;
    line-height: 26*$width;
    color: #959595;
    span {
      &.active {
        color: #212121;
      }
    }
  }
  .ward{
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1250*$width;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    min-width: 0;
    .left{
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      .logo_img{
        flex-shrink: 0;
        width: 120*$width;
        font-size: 0;
        line-height: 0;
        padding-top: 8*$width;
        img{
          width: 100%;
        }
      }
      .list{
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        margin-left: 44*$width;
        position: relative;
        .fontColor {
          font-size: 16*$width;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          position: relative;
          .nav-item-label {
            display: inline-block;
            position: relative;
            vertical-align: top;
          }
          .bottomLine{
            width: 32*$width;
            height: 3*$width;
            position: absolute;
            bottom: -1*$width;
            left: 50%;
            transform: translateX(-50%);
          }
          .nav-project-title {
            display: inline-flex;
            align-items: center;
          }
          .nav-project-arrow {
            width: 12*$width;
            height: 10*$width;
            margin-left: 4*$width;
            flex-shrink: 0;
          }
        }
        .item{
          flex-shrink: 0;
          line-height: 60*$width;
          padding: 0 15*$width;
          position: relative;
          white-space: nowrap;
          .gif{
            position: absolute;
            top: 6*$width;
            left: -5*$width;
          }
          .upTriangle{
            position: absolute;
            width: 20*$width;
            height: 11*$width;
            bottom: 0;
            left: 48*$width;
          }
        }
        .selectItem{
          color: #296BFF;
        }
        .list_bottom{
          position: absolute;
          bottom: 0;
          background: #296BFF;
          width: 28*$width;
          height: 3*$width;
          border-radius: 2*$width;
          transition: all 0.3s;
        }
        .activit{
          color: #212121;
          font-size: 14*$width;
          display: inline-block;
        }
        .drop_position {
          margin-right: -20*$width !important;
        }
        .IndexHeader_left{
          display: inline-block;
          width: 55*$width;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;
      flex-wrap: nowrap;
      justify-content: flex-end;
      gap: 16*$width;
      margin-left: 32*$width;
      .iconBox{
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        height: 60*$width;
        gap: 20*$width;
      }
      /** 伴学助手入口：设计稿 340×34@1920；宽度足够时保持设计宽度并靠右排列，窄屏时可收缩 */
      .ai-entry-pill {
        position: relative;
        flex-shrink: 1;
        width: 340 * $width;
        min-width: 120 * $width;
        max-width: 340 * $width;
        height: 34 * $width;
        padding: 0;
        margin: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        outline: none;
        box-sizing: border-box;
      }
      .ai-entry-pill__img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: fill;
        user-select: none;
        pointer-events: none;
      }
      .ai-entry-pill__fake-input {
        position: absolute;
        left: 118 * $width;
        /** 右侧预留 Ai 图标区（18px 图标 + 边距，随 $width 缩放） */
        right: 38 * $width;
        top: 0;
        height: 34 * $width;
        line-height: 34* $width;
        font-size: 12* $width;
        color: #bfbfbf;
        text-align: left;
        white-space: nowrap;
        pointer-events: none;
        user-select: none;
      }
      /** 中文环境：占位文案相对横幅整体略向左对齐 */
      .ai-entry-pill--locale-zh .ai-entry-pill__fake-input {
        left: calc(#{118 * $width} - #{14 * $width});
      }
      .ai-entry-pill__tail-icon {
        position: absolute;
        right: 14 * $width;
        top: 50%;
        transform: translateY(-50%);
        width: 18 * $width;
        height: 18 * $width;
        object-fit: contain;
        pointer-events: none;
        user-select: none;
      }
      .coachBtn{
        flex-shrink: 0;
        min-width: 62*$width;
        height: 28*$width;
        padding: 0 12*$width;
        //border: 1*$width solid #296BFF;
        text-align: center;
        line-height: 28*$width;
        border-radius: 16*$width;
        font-size: 12*$width;
        //color: #296BFF;
        margin: 0;
        border: 1*$width solid #FFFFFF;
        color: #FFFFFF;
        white-space: nowrap;
      }
      .btn{
        flex-shrink: 0;
        background: #FFFFFF;
        border-radius: 17*$width;
        height: 28*$width;
        //min-height: 28px;
        margin: 0;
        text-align: center;
        color: #fff;
        line-height: 28*$width;
        font-size: 12*$width;
        color: #296BFF;
        padding: 0 12*$width;
        white-space: nowrap;
      }
      .btnBlue{
        flex-shrink: 0;
        background: #296BFF;
        border-radius: 17*$width;
        //min-height: 28px;
        height: 28*$width;
        margin: 0;
        text-align: center;
        color: #fff;
        line-height: 28*$width;
        font-size: 12*$width;
        padding: 0 12*$width;
        border: 1px solid #296BFF;
        white-space: nowrap;
      }
      .user_icon {
        flex-shrink: 0;
        cursor: pointer;
        display: inline-block;
        // margin-left: 80*$width;
        // width: 100*$width;
        margin: 0;
        border: 1*$width solid #d8d8d8;
        overflow: hidden;
        height: 40*$width;
        width: 40*$width;
        min-width: 40*$width;
        min-height: 40*$width;
        line-height: 40*$width !important;
        border-radius: 50%;
        box-sizing: border-box;
        .img_container {
          height: 40*$width;
          width: 40*$width;
          min-width: 40*$width;
          min-height: 40*$width;
          overflow: hidden;
          box-sizing: border-box;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .myActivit{
        flex-shrink: 0;
        margin: 0;
        line-height: 28*$width;
        height: 28*$width;
        padding: 0 12*$width;
        //background-image: linear-gradient(270deg, #2996FF 0%, #296BFF 100%);
        border-radius: 17*$width;
        text-align: center;
        font-size: 12*$width;
        border: 1*$width solid #FFFFFF;
        color: #FFFFFF;
        white-space: nowrap;
      }
      .drop_position {
        margin-right: -20*$width !important;
      }
      .headerPopover {
        .popoverCent{
          background: red;
          .contentItem{
            .itemIn {
              display: flex;
              .itemInIcon{
                width: 20px;
                height: 20px;
                display: block;
              }
              .itemInTxt{
                width: 72px;
                height: 23px;
                font-size: 16px;
                font-family: MicrosoftYaHeiUI;
                color: #212121;
                line-height: 23px;
              }
              .itemInTxtEn {
                margin-left: 17px;
                min-width: 92px;
                height: 23px;
                font-size: 12px;
                font-family: MicrosoftYaHeiUI;
                color: #212121;
                line-height: 23px;
              }
            }
          }
        }
      }
    }
    .Search{
      width: 26*$width;
      margin-right: 20*$width;
      //margin: 16*$width 0*$width;
      //margin-left: 384*$width;
    }
    .Search1 {
      margin-left: 475*$width
    }
    .Search2 {
      margin-left: 415*$width;
    }
    .Search3 {
      margin-left: 512*$width
    }
    .Search4 {
      margin-left: 250*$width;
    }
    .Search5 {
      margin-left: 230*$width;
    }
    .Search6 {
      margin-left: 355*$width
    }
    .activity{
      flex-shrink: 0;
      height: 26*$width;
      font-size: 16*$width;
      color: #030A17;
      line-height: 22*$width;
      //margin-top: 16*$width;
      margin: 0;
      position: relative;
      img{
        width: 26*$width;
        height: 26*$width;
      }
      .blpc{
        font-size: 26*$width;
        color: #FFFFFF;
        font-weight: 100;
      }
      .num{
        position: absolute;
        width: 16*$width;
        height: 16*$width;
        background: #FF2F49;
        border: 1*$width solid #FFFFFF;
        color: #fff;
        font-size: 12*$width;
        line-height: 16*$width;
        text-align: center;
        top: -8*$width;
        right: -8*$width;
        border-radius: 50%;
      }
    }
  }
}
.HeaderBox1{
  background: #FFFFFF;
}
/** 任务页等 bol=false 但伴学打开：不占 60px 导航条高度，避免空白条 */
.HeaderBox--chrome-hidden {
  height: 0 !important;
  min-height: 0 !important;
  overflow: visible;
  box-shadow: none !important;
  background: transparent !important;
  backdrop-filter: none !important;
  position: relative !important;
  top: auto !important;
}
/* 伴学打开时提升整棵头部堆叠上下文，否则子级 .ai-assistant-panel 再高也无法压过父级 z-index:100 外的浮层 */
.HeaderBox--ai-assistant-open {
  z-index: 3000;
}
.H60{
  //height: 60*$width;
  //top: 0;
  //overflow: visible;
}
.ov {

}

/* —— AI 伴学助手全屏下方面板 —— */
$ai-blue: #296bff;
$ai-blue-soft: #e8f0ff;
$ai-text: #212121;
$ai-muted: #666;
$ai-sidebar-bg: #eff3fb;

.ai-assistant-fade-enter-active,
.ai-assistant-fade-leave-active {
  transition: opacity 0.2s ease;
}
.ai-assistant-fade-enter,
.ai-assistant-fade-leave-to {
  opacity: 0;
}

/* 大/小窗切换：与 compact 共用时长与曲线，便于同步 */
$ai-panel-resize-dur: 0.38s;
$ai-panel-resize-ease: cubic-bezier(0.4, 0, 0.2, 1);

.ai-assistant-panel {
  position: fixed;
  left: 0;
  /* 使用显式 width 而非 left+right，便于与窄窗宽度做过渡（right:auto 无法插值） */
  width: 100%;
  max-width: 100%;
  overscroll-behavior: contain;
  /* 首页 HeaderBox 高度为 60*$width，与头部下沿对齐 */
  top: calc(#{60 * $width});
  height: calc(100vh - #{60 * $width});
  min-height: calc(100vh - #{60 * $width});
  box-sizing: border-box;
  /* 须高于任务列表页 .bloom_header（z-index:1000）及站内其它浮层，否则会被盖住 */
  z-index: 3000;
  display: flex;
  align-items: stretch;
  background: #fff;
  outline: none;
  font-family: PingFangSC, 'Microsoft YaHei', sans-serif;
  box-shadow: 0 #{4 * $width} #{24 * $width} rgba(0, 0, 0, 0.06);
  transition:
    left $ai-panel-resize-dur $ai-panel-resize-ease,
    width $ai-panel-resize-dur $ai-panel-resize-ease,
    max-width $ai-panel-resize-dur $ai-panel-resize-ease,
    background-color 0.27s ease,
    box-shadow $ai-panel-resize-dur $ai-panel-resize-ease;
}

/* 活动任务等 Bloom 头（header.vue）固定 60px，与首页缩放头 60*$width 不同 */
.ai-assistant-panel--bloom-route {
  top: 60px;
  height: calc(100vh - 60px);
  min-height: calc(100vh - 60px);
}

/* 英文文案较长：侧栏标签换行、KV 标签限宽、紧凑标题省略 */
.ai-assistant-panel--locale-en {
  .ai-side-label {
    font-size: 13px;
    line-height: 1.25;
    white-space: normal;
    word-break: break-word;
  }
  .ai-cr-label {
    font-size: 12px;
    line-height: 1.35;
  }
  .ai-compact-title {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1;
  }
}

.ai-assistant-panel-body {
  flex: 1;
  display: flex;
  align-items: stretch;
  min-width: 0;
  min-height: 0;
  position: relative;
  border-radius: 0;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition:
    border-radius $ai-panel-resize-dur $ai-panel-resize-ease,
    box-shadow $ai-panel-resize-dur $ai-panel-resize-ease,
    border-color 0.29s ease,
    background-color 0.29s ease;
}

/* 紧凑态：外层不设白底，否则矩形白底会盖住四角外侧，圆角看不出来 */
/* 缩小面板固定 420px，不随 $width 缩放；仅 max-width 防止超出视口 */
.ai-assistant-panel--compact {
  left: 16px;
  width: 420* $width;
  max-width: unquote('calc(100vw - 32px)');
  min-width: 420px;
  overflow: visible;
  z-index: 3000;
  background: transparent;
  box-shadow: none;
}

.ai-assistant-panel--compact .ai-assistant-panel-body {
  background: #fff;
  border-radius: 12px;
  border: 2px solid #D4DAE7;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(41, 55, 100, 0.14);
}

.ai-assistant-panel--compact:not(.ai-assistant-panel--compact-nav-open) .ai-assistant-sidebar {
  display: none;
}

.ai-assistant-panel--compact.ai-assistant-panel--compact-nav-open .ai-assistant-sidebar {
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 200px;
  z-index: 40;
  border-radius: 12px 0 0 12px;
  box-shadow: 3px 0 11px 1px #c8cbd2;
}

.ai-compact-sidebar-backdrop {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 35;
  background: transparent;
}

.ai-assistant-panel--compact .ai-compact-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 10px 0 12px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ebebeb;
}

.ai-compact-menu {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  -webkit-appearance: none;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}

.ai-compact-menu-icon {
  display: block;
  width: 20px;
  height: 16px;
  object-fit: contain;
  pointer-events: none;
}

.ai-compact-title {
  flex: 1;
  min-width: 0;
  font-family: SourceHanSansCN, SourceHanSansCN, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  color: #1e2131;
  text-align: left;
}

.ai-compact-close {
  flex-shrink: 0;
  width: 32 * $width;
  height: 32 * $width;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #666;
  font-size: calc(#{20 * $width} + 8px);
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.15s;
  &:hover {
    color: #333;
  }
}

.ai-assistant-panel--compact .ai-assistant-main {
  padding: 0;
  overflow: hidden;
  background: #fff;
}

.ai-assistant-panel--compact .ai-main-column {
  max-width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.ai-assistant-panel--compact .ai-chat-scroll {
  padding: 12px 10px 0;
}

.ai-assistant-panel--compact .ai-newchat-greet {
  font-size: 16px;
  line-height: 20px;
  color: #212121;
  margin-bottom: 2px;
}

.ai-assistant-panel--compact .ai-msg {
  font-size: 16px;
}

.ai-assistant-panel--compact .ai-answer-wait-loading {
  gap: 8px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 1.5;
}

.ai-assistant-panel--compact .ai-answer-wait-loading__icon {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
}

.ai-assistant-panel--compact .ai-input-field {
  flex: 1;
  min-height: 0;
  font-size: 16px;
  line-height: 20px;
  &::placeholder {
    font-size: 16px;
    line-height: 20px;
  }
}

.ai-assistant-panel--compact .ai-newchat-cards {
  margin-top: 16px;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.ai-assistant-panel--compact .ai-feature-card {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 450 / 152;
  //min-height: 132px;
  height: auto;
  padding: 14px 90px 14px 16px;
  border-radius: 12px;
  box-shadow: none;
}

.ai-assistant-panel--compact .ai-feature-card-text {
  max-width: 100%;
}

.ai-assistant-panel--compact .ai-feature-card-title {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 6px;
}

.ai-assistant-panel--compact .ai-feature-card-desc {
  font-size: 12px;
  line-height: 18px;
  color: #212121;
}

/* 缩小模式：不占纵向空间；子级相对 footer 绝对定位（勿用 display:contents，避免包含块/裁剪问题） */
.ai-prompts-wrap--compact {
  height: 0;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
  flex-shrink: 0;
  align-self: stretch;
  pointer-events: none;
}

/* 三个 chip 单行展示，不足宽度时横向滑动且隐藏滚动条 */
.ai-prompts-wrap .ai-quick-prompts {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.ai-assistant-panel--compact .ai-quick-prompts {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: calc(100% + 4px);
  z-index: 2;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 0;
  justify-content: flex-start;
  width: auto;
  pointer-events: auto;
}

.ai-assistant-panel--compact .ai-chip {
  flex: 0 0 auto;
  width: calc((100% - 16px) / 3);
  min-width: 120px;
  max-width: none;
  height: 48px;
  min-height: 48px;
  box-sizing: border-box;
  padding: 0 8px;
  border-radius: 12px;
  background: linear-gradient(270deg, #eef9ff 0%, #f8f8f8 100%);
}

.ai-assistant-panel--compact .ai-chip-title {
  font-family: PingFangSC, 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #030a17;
  text-align: center;
  font-style: normal;
  align-self: stretch;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ai-assistant-panel--compact .ai-chip-hint {
  font-family: PingFangSC, 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #80889a;
  text-align: center;
  font-style: normal;
  margin-top: 0;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.ai-assistant-panel--compact .ai-assistant-footer {
  position: relative;
  z-index: 1;
  padding: 0;
  border-top: 2px solid #d4dae7;
  height: 150px;
  min-height: 150px;
  max-height: 150px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  /* 允许 ai-quick-prompts 绝对定位到上边框外，避免被裁切 */
  overflow: visible;
}

.ai-assistant-panel--compact .ai-input-wrap {
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 10px;
  padding: 0;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.ai-assistant-panel--compact .ai-input-gradient {
  flex: 1;
  min-height: 0;
  padding: 10px 12px;
  gap: 0;
  border-radius: 8px;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.ai-assistant-panel--compact .ai-compact-footer-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 0 6px 0 16px;
  gap: 8px;
  box-sizing: border-box;
}

.ai-assistant-panel--compact .ai-compact-footer-bar .ai-disclaimer {
  margin: 0;
  flex: 1;
  min-width: 0;
  text-align: left;
  font-size: 11px;
  line-height: 16px;
  color: #BABDC3;
}

.ai-assistant-panel--compact .ai-compact-footer-bar .ai-send-row {
  position: static;
  flex-shrink: 0;
  margin: 0;
}

.ai-assistant-panel--compact .ai-compact-footer-bar .ai-send-btn {
  width: 48px;
  height: 48px;
  img {
    width: 48px;
    height: 48px;
  }
}

.ai-assistant-panel--compact .ai-msg--user {
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 16px;
}

.ai-assistant-panel--compact .ai-recommend-row {
  flex-direction: column;
}

.ai-assistant-panel--compact .ai-activity-card {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.ai-assistant-panel--compact .ai-card-title {
  font-size: 14px;
}

.ai-assistant-panel--compact .ai-card-meta {
  font-size: 12px;
}

.ai-assistant-panel--compact .ai-contest-recommend-card {
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 14px 0;
  border-radius: 12px;
}

.ai-assistant-panel--compact .ai-contest-cards-wrap {
  grid-template-columns: 1fr;
  column-gap: 0;
  row-gap: 20px;
  justify-items: center;
}

.ai-assistant-panel--compact .ai-cr-detail-btn {
  font-size: 13px;
  width: 219px;
  max-width: 100%;
  height: 36px;
  padding: 0;
  margin: 8px auto 10px;
}

/* 缩小模式：推荐活动卡片字号/图标固定 px，不随 $width 继续缩小 */
.ai-assistant-panel--compact .ai-cr-row {
  gap: 8px;
  padding: 6px 0;
}

.ai-assistant-panel--compact .ai-cr-row--challenge {
  padding-right: 72px;
}

.ai-assistant-panel--compact .ai-cr-ico,
.ai-assistant-panel--compact .ai-cr-ico-img {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
}

.ai-assistant-panel--compact .ai-cr-row-text {
  font-size: 14px;
  line-height: 1.5;
}

.ai-assistant-panel--compact .ai-cr-kv {
  column-gap: 8px;
  row-gap: 4px;
}

.ai-assistant-panel--compact .ai-cr-label {
  font-size: 14px;
  line-height: 20px;
  max-width: none;
}

.ai-assistant-panel--compact .ai-cr-name,
.ai-assistant-panel--compact .ai-cr-value,
.ai-assistant-panel--compact .ai-cr-reason {
  font-size: 14px;
  line-height: 20px;
}

.ai-assistant-panel--compact .ai-cr-stars {
  gap: 4px;
}

.ai-assistant-panel--compact .ai-cr-star-item {
  width: 14px;
  height: 13px;
  min-width: 14px;
  min-height: 13px;
}

.ai-assistant-panel--compact.ai-assistant-panel--locale-en .ai-cr-label {
  font-size: 14px;
  line-height: 20px;
}

.ai-assistant-panel--compact .ai-assistant-shrink-btn {
  top: 50%;
  transform: translateY(-50%);
  right: -20 * $width;
  z-index: 45;
}

.ai-assistant-sidebar {
  width: 200px;
  min-width: 200px;
  flex-shrink: 0;
  align-self: stretch;
  min-height: 0;
  background: $ai-sidebar-bg;
  padding: 24 * $width 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4 * $width;
  overflow-x: hidden;
  /* 纵向滚动仅发生在「历史对话」子列表内，侧栏整体不滚动 */
  overflow-y: hidden;
  overscroll-behavior: contain;
}

/* 非激活与激活：同一宽高、圆角；侧栏内由 align-items:center 水平居中 */
.ai-side-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10 * $width;
  width: 166px;
  height: 47px;
  box-sizing: border-box;
  padding: 0 16px;
  margin: 0;
  border: none;
  border-radius: 24px;
  color: $ai-text;
  cursor: pointer;
  transition: background 0.15s;
  background: transparent;
  font: inherit;
  text-align: left;
  appearance: none;
  -webkit-appearance: none;
  &:hover {
    background: rgba(41, 107, 255, 0.06);
  }
  &.is-active {
    background: linear-gradient(270deg, #ceecff 0%, #c5d7ff 100%);
    color: $ai-text;
    &:hover {
      background: linear-gradient(270deg, #ceecff 0%, #c5d7ff 100%);
    }
    .ai-side-label {
      font-weight: 500;
      color: $ai-text;
    }
  }
}
.ai-side-label {
  font-size: 16px;
  line-height: 20px;
  font-family: PingFangSC, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: $ai-text;
}
/* 历史对话：大 tab 不使用胶囊激活态（与开启新对话等区分） */
.ai-side-item--history {
  .ai-side-chevron-img {
    width: 13px;
    height: 8px;
    margin-left: auto;
    flex-shrink: 0;
    object-fit: contain;
    display: block;
    cursor: pointer;
    transition: transform 0.2s ease;
    transform: rotate(0deg);
  }
  .ai-side-chevron-img--rotated {
    transform: rotate(180deg);
  }
}

.ai-sidebar-history-block {
  width: 166px;
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: center;
  box-sizing: border-box;
  overflow: hidden;
}

.ai-sidebar-history-list {
  width: 100%;
  margin-top: 2 * $width;
  padding: 0;
  box-sizing: border-box;
  flex: 1 1 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.ai-sidebar-history-items {
  list-style: none;
  margin: 0;
  padding: 0 0 0 12px;
  /* 竖线落在「历史对话」图标宽度正中：左 padding 16px + 图标半宽 10px − 边框半宽 0.5px */
  margin-left: calc(16px + 10px - 0.5px);
  border-left: 1px solid #CDD2DC;
  box-sizing: border-box;
}

.ai-sidebar-history-li {
  margin-bottom: 6px;
  &:last-child {
    margin-bottom: 0;
  }
}

.ai-sidebar-history-link {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
  font-family: PingFangSC, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.15s, background 0.15s;
  color: #5E6169;
  &:hover {
    color: #212121;
  }
  &.is-selected {
    color: #296bff;
    font-weight: 500;
  }
}
.ai-side-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
}

.ai-assistant-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100%;
  position: relative;
  background: #fff;
  padding: 0 24 * $width;
  box-sizing: border-box;
}

/* 右侧聊天区版心与设计稿 964@1920 等比：964 * (100vw/1920) */
.ai-main-column {
  max-width: 964 * $width;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  padding: 0;
}

.ai-assistant-shrink-btn {
  position: absolute;
  top: 440 * $width;
  right: 4 * $width;
  z-index: 15;
  box-sizing: border-box;
  width: 40 * $width;
  height: 80 * $width;
  padding: 0;
  border: 1px solid #d4dae7;
  border-radius: 40 * $width;
  overflow: hidden;
  background: #fff;
  box-shadow: 0px 0px 4px 0px #D7DADF;
  cursor: pointer;
  line-height: 0;
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    top $ai-panel-resize-dur $ai-panel-resize-ease,
    right $ai-panel-resize-dur $ai-panel-resize-ease,
    transform $ai-panel-resize-dur $ai-panel-resize-ease;
}

.ai-assistant-shrink-btn-icon {
  display: block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  object-fit: contain;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.ai-assistant-shrink-btn-icon--expanded {
  transform: rotate(180deg);
}

@media (prefers-reduced-motion: reduce) {
  .ai-assistant-panel,
  .ai-assistant-panel-body,
  .ai-assistant-shrink-btn {
    transition-duration: 0.01ms !important;
  }
  .ai-assistant-shrink-btn-icon {
    transition-duration: 0.01ms !important;
  }
}

.ai-assistant-close {
  position: absolute;
  top: 16 * $width;
  right: 24 * $width;
  width: 32 * $width;
  height: 32 * $width;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  overflow: hidden;
  &:hover {
    opacity: 0.92;
  }
}
.ai-assistant-close-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ai-chat-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-top: 24 * $width;
  padding-right: 24 * $width;
  padding-bottom: 0;
  padding-left: 24 * $width;
  box-sizing: border-box;
  background: #fff;
}

/* 开启新对话 · 双卡片推荐入口（设计稿 450×152 + 背景图） */
.ai-newchat-wrap {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
}
.ai-newchat-greet {
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  font-family: PingFangSC, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #212121;
  line-height: 22px;
  font-style: normal;
  direction: ltr;
}
.ai-newchat-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  gap: 16 * $width;
  width: 100%;
  margin-top: 240 * $width;
  box-sizing: border-box;
}
.ai-feature-card {
  position: relative;
  width: auto;
  flex: 1 1 calc(50% - #{8 * $width});
  max-width: unquote('min(100%, #{450 * $width})');
  height: auto;
  min-height: 152 * $width;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: none;
  border-radius: 12 * $width;
  cursor: pointer;
  text-align: left;
  font: inherit;
  appearance: none;
  -webkit-appearance: none;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center right;
  box-shadow: none;
  padding: 20 * $width unquote('clamp(100px, 42%, #{200 * $width})') 20 * $width 24 * $width;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-#{2 * $width});
    box-shadow: 0 #{8 * $width} #{24 * $width} rgba(41, 107, 255, 0.12);
  }
}
.ai-feature-card--recommend {
  background-image: url('https://img.webloom.cn/Img/ai-tuijianBg.webp');
}
.ai-feature-card--topic {
  background-image: url('https://img.webloom.cn/Img/banxuexuantibg.webp');
}
.ai-feature-card-text {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.ai-feature-card-title {
  margin: 0 0 #{8 * $width};
  font-family: PingFangSC, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #296bff;
  font-style: normal;
  word-break: keep-all;
}
.ai-feature-card-desc {
  margin: 0;
  font-family: PingFangSC-Regular, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #212121;
  font-style: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.ai-msg {
  margin: 0 auto 16 * $width;
  font-size: 16px;
  line-height: 1.65;
  color: $ai-text;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}
.ai-msg--assistant {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}

.ai-answer-slot {
  position: relative;
  min-height: 0;
}
.ai-answer-below-thinking {
  min-height: 0;
}
.ai-answer-wait-loading {
  display: flex;
  align-items: center;
  gap: 8 * $width;
  margin: 0 auto 16 * $width;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.5;
  color: #5c6370;
}
.ai-answer-wait-loading__icon {
  width: 20 * $width;
  height: 20 * $width;
  flex-shrink: 0;
  display: block;
}
.ai-answer-wait-loading__text {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}
.ai-answer-wait-loading__dots {
  display: inline-block;
  min-width: 3ch;
  text-align: left;
}

/* 与活动卡片相邻的助手说明文案：保留换行 */
.ai-msg--assistant-fragment {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* IM750 messageData.kind=error：仅用 errMessage 展示，不写入 agentRes */
.ai-im750-error-tip {
  margin: 0 auto 12 * $width;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 10 * $width 14 * $width;
  border-radius: 10 * $width;
  border: 1px solid rgba(224, 28, 28, 0.32);
  background: rgba(224, 28, 28, 0.07);
  color: #b71c1c;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}

.ai-im750-user-stop-tip {
  margin: 0 auto 12 * $width;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 10 * $width 14 * $width;
  border-radius: 10 * $width;
  border: 1px solid rgba(25, 118, 210, 0.28);
  background: rgba(25, 118, 210, 0.06);
  color: #1565c0;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}

.ai-msg--user {
  margin: 0 0 16 * $width auto;
  width: fit-content;
  max-width: 100%;
  padding: 12 * $width 16 * $width;
  background: #f3f5f9;
  border-radius: 12px;
  color: $ai-text;
  font-size: 16px;
  word-break: break-word;
  overflow-wrap: break-word;
}

.ai-agent-res-part {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
}

/* 多卡片容器：固定卡片宽下一行最多 2 个，列间距与行间距均为 44px（随 $width 缩放） */
.ai-contest-cards-wrap {
  display: grid;
  grid-template-columns: repeat(2, 372 * $width);
  column-gap: 44 * $width;
  row-gap: 44 * $width;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 auto 16 * $width;
  justify-content: start;
  justify-items: start;
}

/* 伴学助手：IM kind=fence · ```contestFence``` 活动推荐卡片（设计稿 372×343 / #D9DDE5 边框） */
.ai-contest-recommend-card {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  width: 372 * $width;
  min-height: 343 * $width;
  box-sizing: border-box;
  padding: 10 * $width 14 * $width 0;
  margin: 0;
  background: #ffffff;
  border: 1px solid #d9dde5;
  border-radius: 12 * $width;
  text-align: left;
  overflow: visible;
}

.ai-cr-card-body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 2 * $width;
}

/* 悬浮在卡片右上角；「报名中」为固定底图 + 文案 */
.ai-cr-badge {
  position: absolute;
  top: -3 * $width;
  right: 0 * $width;
  z-index: 2;
  box-sizing: border-box;
  font-style: normal;
  text-align: center;
}

.ai-cr-badge--open {
  width: 50px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: url('https://img.webloom.cn/Img/aiCard-baomingzhon.png') no-repeat center /
    100% 100%;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi, -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #e01c1f;
  /* 设计稿写 line-height:50px 与高度 20px 矛盾，按 20px 盒内垂直居中 */
  line-height: 20px;
  border-radius: 4px 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-cr-badge--end,
.ai-cr-badge--pending {
  width: auto;
  min-width: 50px;
  height: 20px;
  padding: 0 8px;
  border-radius: 8px 8px 8px 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-cr-badge--end {
  background: #f0f0f0;
  color: #888888;
}

.ai-cr-badge--pending {
  background: #e3f2fd;
  color: #1976d2;
}

.ai-cr-row {
  display: flex;
  align-items: center;
  gap: 10 * $width;
  padding: 5 * $width 0;
  border-bottom: 1px solid #ebedf2;
}

.ai-cr-row--challenge {
  /* 避让角标：距右 32 + 宽约 50 + 余量 */
  padding-right: 90 * $width;
}

.ai-cr-row--last {
  border-bottom: none;
  align-items: flex-start;
}

/* 行首图标：设计稿 18×18（随 $width 缩放） */
.ai-cr-ico {
  flex-shrink: 0;
  width: 18 * $width;
  height: 18 * $width;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ai-cr-ico-img {
  display: block;
  width: 18 * $width;
  height: 18 * $width;
  object-fit: contain;
}

.ai-cr-row-text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: $ai-text;
  line-height: 1.5;
}

.ai-cr-kv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 12 * $width;
  row-gap: 4 * $width;
}

.ai-cr-kv--challenge .ai-cr-name {
  flex: 1;
  min-width: 0;
}

.ai-cr-kv--stars {
  align-items: center;
}

.ai-cr-kv--stack {
  align-items: flex-start;
  width: 100%;
}

/* 推荐理由：标题在上、正文整行宽度，避免左右分栏左侧大块留白 */
.ai-cr-kv--reason {
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  column-gap: 0;
  row-gap: 4 * $width;
}

.ai-cr-kv--reason .ai-cr-label {
  max-width: none;
}

.ai-cr-kv--reason .ai-cr-reason {
  flex: none;
  width: 100%;
}

.ai-cr-label {
  box-sizing: border-box;
  flex-shrink: 1;
  min-width: 0;
  max-width: 150px;
  font-family: SourceHanSansCN, SourceHanSansCN, 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #1e2131;
  text-align: left;
  font-style: normal;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

.ai-cr-name,
.ai-cr-value {
  font-family: SourceHanSansCN, SourceHanSansCN, 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #1e2131;
  line-height: 18px;
  //text-align: justify;
  font-style: normal;
  word-break: break-word;
}

.ai-cr-name {
  margin: 0;
}

.ai-cr-value {
  flex: 1;
  min-width: 0;
}

.ai-cr-stars {
  display: inline-flex;
  align-items: center;
  gap: 4 * $width;
}

/* 与 bloom-H5 .asa-rec-star-item-img-box 同源切图，尺寸按 PC 卡片 $width 缩放（H5 约 28×27） */
.ai-cr-star-item {
  width: 14 * $width;
  height: 13 * $width;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

.ai-cr-star-item img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.ai-cr-reason {
  margin: 0;
  padding: 0;
  font-family: SourceHanSansCN, SourceHanSansCN, 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #1e2131;
  line-height: 18px;
  //text-align: justify;
  font-style: normal;
  white-space: pre-wrap;
  word-break: break-word;
}

.ai-cr-detail-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 219 * $width;
  height: 36 * $width;
  margin: 8 * $width auto 12 * $width;
  padding: 0;
  border: none;
  border-radius: 8 * $width;
  background: #e9f0ff;
  color: #296bff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: background 0.15s, color 0.15s;
  box-sizing: border-box;
}

.ai-cr-detail-btn:hover {
  background: #dbe8ff;
  color: #1e56d9;
}

.ai-recommend-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20 * $width;
  margin-top: 8 * $width;
  justify-content: center;
}

.ai-activity-card {
  flex: 1 1 calc(50% - #{10 * $width});
  min-width: 260 * $width;
  max-width: none;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12 * $width;
  box-shadow: 0 #{4 * $width} #{16 * $width} rgba(0, 0, 0, 0.06);
  padding: 16 * $width 18 * $width 0;
  box-sizing: border-box;
}

.ai-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12 * $width;
  margin-bottom: 12 * $width;
}
.ai-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: $ai-text;
  line-height: 1.4;
}
.ai-card-tag {
  flex-shrink: 0;
  font-size: 12px;
  padding: 2 * $width 10 * $width;
  border-radius: 4 * $width;
  font-weight: 500;
}
.ai-card-tag--open {
  background: #ffe8e8;
  color: #e53935;
}
.ai-card-tag--end {
  background: #f0f0f0;
  color: #888;
}

.ai-card-meta {
  list-style: none;
  margin: 0 0 16 * $width;
  padding: 0;
  font-size: 13px;
  color: $ai-muted;
  line-height: 1.7;
  li {
    display: flex;
    align-items: flex-start;
    gap: 8 * $width;
    margin-bottom: 6 * $width;
  }
}
.dot {
  width: 6 * $width;
  height: 6 * $width;
  border-radius: 50%;
  margin-top: 7 * $width;
  flex-shrink: 0;
}
.dot-b { background: #296bff; }
.dot-g { background: #4caf50; }
.dot-o { background: #ff9800; }
.dot-y { background: #ffc107; }
.dot-p { background: #9c27b0; }

.ai-card-btn {
  display: block;
  width: calc(100% + #{36 * $width});
  margin-left: -18 * $width;
  margin-right: -18 * $width;
  border: none;
  border-radius: 0 0 12 * $width 12 * $width;
  padding: 12 * $width;
  background: $ai-blue-soft;
  color: $ai-blue;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #dbe4fc;
  }
}

.ai-assistant-footer {
  flex-shrink: 0;
  padding: 0 0 20 * $width;
  box-sizing: border-box;
  background: #fff;
  width: 100%;
}

.ai-quick-prompts {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12 * $width;
  width: 100%;
  justify-content: flex-start;
}

.ai-chip {
  width: 174px;
  height: 69px;
  box-sizing: border-box;
  border: none;
  border-radius: 12px;
  background: linear-gradient(270deg, #eef9ff 0%, #f8f8f8 100%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  transition: opacity 0.15s;
  &:hover {
    cursor: pointer;
    opacity: 0.88;
  }
}

.ai-chip-title,
.ai-chip-hint {
  cursor: inherit;
  pointer-events: none;
  user-select: none;
}

.ai-chip-title {
  font-family: PingFangSC, 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  align-self: stretch;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ai-chip-hint {
  margin-top: 2px;
  font-family: PingFangSC, 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #80889a;
  line-height: 17px;
  text-align: center;
  font-style: normal;
  align-self: stretch;
  min-width: 0;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 全屏模式：显式恢复 $width 设计稿样式，与紧凑态固定 px 隔离 */
.ai-assistant-panel:not(.ai-assistant-panel--compact) {
  left: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  background: #fff;
  box-shadow: 0 #{4 * $width} #{24 * $width} rgba(0, 0, 0, 0.06);

  .ai-assistant-main {
    padding: 0 24 * $width;
  }

  .ai-main-column {
    max-width: 964 * $width;
    padding: 0;
  }

  .ai-chat-scroll {
    padding: 24 * $width 24 * $width 0;
  }

  .ai-newchat-cards {
    margin-top: 240 * $width;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
    gap: 16 * $width;
  }

  .ai-feature-card {
    width: auto;
    flex: 1 1 calc(50% - #{8 * $width});
    max-width: unquote('min(100%, #{450 * $width})');
    height: auto;
    aspect-ratio: auto;
    min-height: 152 * $width;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    background-size: cover;
    padding: 20 * $width unquote('clamp(100px, 42%, #{200 * $width})') 20 * $width 24 * $width;
    border-radius: 12 * $width;
  }

  .ai-feature-card-text {
    max-width: 100%;
    width: 100%;
  }

  .ai-feature-card-title {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 8 * $width;
    word-break: keep-all;
  }

  .ai-feature-card-desc {
    font-size: 13px;
    line-height: 20px;
  }

  .ai-quick-prompts {
    position: static;
    left: auto;
    right: auto;
    bottom: auto;
    z-index: auto;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12 * $width;
    width: 100%;
    pointer-events: auto;
  }

  .ai-chip {
    flex: 0 0 auto;
    width: 174px;
    min-width: 174px;
    max-width: none;
    height: 69px;
    min-height: 69px;
    padding: 8px 10px;
    border-radius: 12px;
  }

  .ai-chip-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #212121;
  }

  .ai-chip-hint {
    font-size: 12px;
    line-height: 17px;
    margin-top: 2px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  .ai-assistant-footer {
    position: static;
    border-top: none;
    height: auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
    padding: 0 0 20 * $width;
  }

  .ai-input-wrap {
    background: linear-gradient(138deg, rgba(59, 167, 255, 1), rgba(120, 83, 249, 1));
    box-shadow: 0 4px 12px 2px #e7e9ed;
    border-radius: 12px;
    padding: 2px;
  }

  .ai-input-gradient {
    padding: 12 * $width 12 * $width 0 16 * $width;
    gap: 12 * $width;
    border-radius: 10px;
  }

  .ai-msg--user {
    border-radius: 12px;
    padding: 12 * $width 16 * $width;
  }

  .ai-contest-recommend-card {
    width: 372 * $width;
    max-width: none;
    min-height: 343 * $width;
    padding: 10 * $width 14 * $width 0;
  }

  .ai-contest-cards-wrap {
    grid-template-columns: repeat(2, 372 * $width);
    column-gap: 44 * $width;
    row-gap: 44 * $width;
  }

  .ai-cr-detail-btn {
    font-size: 13 * $width;
    width: 219 * $width;
    max-width: none;
    height: 36 * $width;
    margin: 8 * $width auto 10 * $width;
  }

  .ai-card-title {
    font-size: 14 * $width;
  }

  .ai-card-meta {
    font-size: 12 * $width;
  }

  .ai-assistant-shrink-btn {
    top: 440 * $width;
    right: 4 * $width;
    transform: none;
  }
}

/* 放大模式 + 视口 < 1200px：推荐活动卡片单列，宽度 300px～500px */
@media (max-width: 1199px) {
  .ai-assistant-panel:not(.ai-assistant-panel--compact) .ai-contest-cards-wrap {
    grid-template-columns: 1fr;
    justify-content: center;
    justify-items: center;
    column-gap: 0;
    row-gap: 24px;
  }

  .ai-assistant-panel:not(.ai-assistant-panel--compact) .ai-contest-recommend-card {
    width: unquote('clamp(300px, 100%, 500px)');
    max-width: 500px;
    min-width: 300px;
    box-sizing: border-box;
  }
}

@media (max-width: 980px) {
  .ai-assistant-panel:not(.ai-assistant-panel--compact) .ai-newchat-cards {
    justify-content: center;
    gap: 20 * $width;
  }
  .ai-assistant-panel:not(.ai-assistant-panel--compact) .ai-feature-card {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 152 * $width;
    padding: 20 * $width unquote('clamp(100px, 38%, 180px)') 20 * $width 20 * $width;
  }
}

/* 渐变描边 + 圆角；缩小模式由 .ai-assistant-panel--compact .ai-input-wrap 覆盖 */
.ai-input-wrap {
  background: linear-gradient(138deg, rgba(59, 167, 255, 1), rgba(120, 83, 249, 1));
  box-shadow: 0 4px 12px 2px #e7e9ed;
  border-radius: 12px;
  padding: 2px;
  box-sizing: border-box;
}

/* 等待 IM / 发送中：渐变描边略变浅（不改变内区文案样式） */
.ai-input-wrap--locked {
  background: linear-gradient(138deg, rgba(59, 167, 255, 0.58), rgba(120, 83, 249, 0.58));
  box-shadow: 0 4px 12px 2px rgba(231, 233, 237, 0.92);
}

.ai-assistant-panel--compact .ai-input-wrap.ai-input-wrap--locked {
  background: transparent;
  box-shadow: 0 0 0 1px rgba(212, 218, 231, 0.75);
}

.ai-input-gradient {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12 * $width;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 12 * $width 12 * $width 0 16 * $width;
}

.ai-input-field {
  display: block;
  width: 100%;
  border: none;
  resize: none;
  font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #1e2131;
  text-align: left;
  font-style: normal;
  overflow: hidden;
  &::placeholder {
    font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #9499a4;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    opacity: 1;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 1;
    color: #1e2131;
    -webkit-text-fill-color: #1e2131;
    background: transparent;
    /* 禁用态仍用 -webkit-text-fill 保持正文色时，需单独把 placeholder 拉回灰色 */
    &::placeholder {
      color: #9499a4;
      -webkit-text-fill-color: #9499a4;
      opacity: 1;
    }
  }
}

.ai-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.9;
}

.ai-send-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
}

.ai-send-btn {
  width: 66px;
  height: 66px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: block;
  line-height: 0;
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.88;
  }
  img {
    width: 66px;
    height: 66px;
    display: block;
    object-fit: contain;
  }
}

.ai-disclaimer {
  margin: 12 * $width 0 0;
  text-align: center;
  font-size: 12px;
  color: #BABDC3;
}

@media (max-width: 900px) {
  .ai-recommend-row {
    flex-direction: column;
  }
  .ai-activity-card {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/header-box.vue